/* ============================================================
   AM by Anita Mittal - Theme JS (Gecko companion layer)
   Built by SAT LABS CO
   ============================================================ */
(function () {
  'use strict';

  /* Linkify Product Colors swaps a card photo to the hovered colour using a
     480px copy. Cards here are wider than that on retina, so ask for 700px. */
  if (!window.webyzeProductColors_imgUrl) {
    window.webyzeProductColors_imgUrl = function (u) { return String(u).split('?')[0] + '?width=700'; };
  }

  /* ---------------- helpers ---------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function amSafeCall(fn) { try { fn(); } catch (e) { if (window.console && console.error) { console.error('[AM]', e); } } }

  var toastTimer = null;
  function amToast(msg) {
    var t = $('#am-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'am-toast';
      t.id = 'am-toast';
      t.innerHTML = '<span class="am-ck"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12.5 10 17.5 19 7"/></svg></span><span class="am-toast-msg"></span>';
      document.body.appendChild(t);
    }
    $('.am-toast-msg', t).textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2400);
  }
  window.amToast = amToast;

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-am-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          /* the badge is hidden at zero, so keep the flag in step */
          if (cart.item_count > 0) { el.removeAttribute('data-zero'); } else { el.setAttribute('data-zero', '1'); }
        });
      }).catch(function () {});
  }

  /* Lightweight cart prime: fetch the cart payload once so it is cached.
     We deliberately do NOT touch the drawer DOM or Gecko's lazyload classes -
     doing so left the drawer stuck on its skeleton because Gecko could no
     longer hydrate its own markup. Gecko renders the drawer itself on open. */
  function prewarmCartDrawer() {
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).catch(function () {});
    }
    $$('.am-cart-link').forEach(function (link) {
      on(link, 'mouseenter', warm);
      on(link, 'touchstart', warm);
      on(link, 'focus', warm);
    });
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm, { timeout: 2500 });
    } else {
      setTimeout(warm, 1800);
    }
  }

  function ajaxAdd(items, btn, after, msg) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    /* Ask Shopify to also return the re-rendered cart sections in the add
       response, so we can hand them straight to Gecko's own renderer. This is
       what makes the drawer show real content instead of a stuck skeleton. */
    var body = { items: items };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function (res) {
      updateCartCount();
      /* refresh our own drawer with the new cart */
      try { document.dispatchEvent(new CustomEvent('am:cart:refresh')); } catch (e) {}
      if (after === 'cart') { window.location.href = '/cart'; return res; }
      if (after === 'drawer') { openCartDrawer(msg); return res; }
      if (after !== 'none') { amToast(msg || 'Added to your bag'); }
      return res;
    }).catch(function (e) {
      var em = (e && e.description) || 'Could not add to bag';
      if (/sold out|not available|unavailable|stock/i.test(em)) {
        em = 'This piece is made to order - please enable "Continue selling when out of stock" on this variant.';
      }
      amToast(em);
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    });
  }

  /* Open Gecko's mini cart drawer after an AJAX add.
     IMPORTANT: we do NOT swap the drawer's innerHTML - doing that destroyed
     Gecko's own event bindings and left the drawer stuck on its skeleton.
     Instead we tell Gecko to reload its cart (its own JS re-renders the drawer
     correctly) and then trigger its native drawer open. */
  function openCartDrawer(msg) {
    /* Use our own self-contained drawer - reliable on live. */
    if (window.__AMCartReady !== false) {
      try {
        document.dispatchEvent(new CustomEvent('am:cart:open'));
        /* GoKwik listens for this name to rescan for checkout buttons */
        try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
        return;
      } catch (e) {}
    }
    /* fallback: Gecko drawer if ours somehow is not present */
    var drawer = document.querySelector('#am-cart-drawer') || document.querySelector('#t4s-mini_cart');
    if (!drawer) { amToast(msg || 'Added to your bag'); return; }
    var SP = window.T4SThemeSP;
    try { document.dispatchEvent(new CustomEvent('cart:refresh:opend')); } catch (e) {}
    if (SP && SP.Drawer && typeof SP.Drawer.opend === 'function') {
      try { SP.Drawer.opend(drawer); return; } catch (e) {}
    }
  }

  function forceOpen(drawer, msg) {
    drawer.classList.remove('t4s-dn');
    drawer.classList.add('t4s-drawer__open', 'is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('t4s-drawer-open');
    var ov = document.querySelector('.t4s-drawer__overlay, #t4s-overlay');
    if (ov) ov.classList.add('is-visible');
  }

  /* ---------------- wishlist (localStorage) ---------------- */
  var WKEY = 'am_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishSet(arr) { try { localStorage.setItem(WKEY, JSON.stringify(arr)); } catch (e) {} }
  function wishPaint(btn, onState) {
    btn.classList.toggle('is-on', onState);
    var svg = btn.querySelector('svg');
    if (svg) { svg.setAttribute('fill', onState ? 'currentColor' : 'none'); }
  }
  function wishBadge() {
    /* header (and drawer) counter - hidden entirely at zero rather than
       showing a 0, which reads as a broken badge */
    var n = wishGet().length;
    $$('[data-am-wish-badge]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
    });
  }
  function wishInit() {
    var list = wishGet();
    $$('[data-am-wish]').forEach(function (btn) {
      wishPaint(btn, list.indexOf(btn.getAttribute('data-am-wish')) > -1);
    });
    wishBadge();
  }
  window.addEventListener('storage', function (e) { if (e.key === WKEY) wishInit(); });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-am-wish]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var h = btn.getAttribute('data-am-wish');
    var list = wishGet();
    var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); } else { list.push(h); }
    wishSet(list);
    $$('[data-am-wish="' + h + '"]').forEach(function (b) { wishPaint(b, i === -1); });
    wishBadge();
    amToast(i === -1 ? 'Added to wishlist' : 'Removed from wishlist');
  });

  /* ---------------- wishlist page ----------------
     The list is a set of product handles in localStorage, so it cannot be
     rendered by Liquid. Each handle is fetched from /products/{handle}.js and
     drawn into the grid. Handles that no longer resolve (deleted or unpublished
     products) are dropped from storage so the list cannot rot. */
  function initWishlistPage(root) {
    if (!root || root.__amWish) return; root.__amWish = true;
    var grid = $('[data-am-wish-grid]', root);
    var emptyEl = $('[data-am-wish-empty]', root);
    var loadEl = $('[data-am-wish-loading]', root);
    var headEl = $('[data-am-wish-head]', root);
    var countEl = $('[data-am-wish-count]', root);
    var clearBtn = $('[data-am-wish-clear]', root);
    if (!grid) return;

    function money(cents) {
      try { return AMCart.money(cents); } catch (e) { return ''; }
    }

    function show(state) {
      if (loadEl) loadEl.hidden = state !== 'loading';
      if (emptyEl) emptyEl.hidden = state !== 'empty';
      if (grid) grid.hidden = state !== 'list';
      if (headEl) headEl.hidden = state !== 'list';
    }

    function card(p) {
      var a = document.createElement('div');
      a.className = 'am-wish-card';
      a.setAttribute('data-handle', p.handle);
      var img = (p.featured_image || (p.images && p.images[0]) || '');
      if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
      var price = money(p.price);
      var compare = p.compare_at_price && p.compare_at_price > p.price ? money(p.compare_at_price) : '';
      var sold = p.available === false;
      var html = '';
      html += '<a class="am-wish-media" href="/products/' + p.handle + '">';
      html += img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="am-wish-noimg"></span>';
      if (sold) { html += '<span class="am-wish-sold">Sold out</span>'; }
      html += '</a>';
      html += '<button type="button" class="am-wish-remove" data-am-wish-remove aria-label="Remove from wishlist">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="5.5" y1="5.5" x2="18.5" y2="18.5"/><line x1="18.5" y1="5.5" x2="5.5" y2="18.5"/></svg>';
      html += '</button>';
      html += '<div class="am-wish-body">';
      html += '<a class="am-wish-title" href="/products/' + p.handle + '"></a>';
      html += '<div class="am-wish-price"><span>' + price + '</span>' + (compare ? ' <s>' + compare + '</s>' : '') + '</div>';
      html += sold
        ? '<span class="am-wish-btn am-wish-btn--off">Unavailable</span>'
        : '<button type="button" class="am-wish-btn" data-am-wish-add data-vid="' + (p.variants && p.variants[0] ? p.variants[0].id : '') + '">Add to Bag</button>';
      html += '</div>';
      a.innerHTML = html;
      /* title via textContent so a quote or ampersand in a product name cannot
         break the markup */
      var t = a.querySelector('.am-wish-title');
      if (t) t.textContent = p.title || p.handle;
      return a;
    }

    function paint() {
      var handles = wishGet();
      if (!handles.length) { show('empty'); return; }
      show('loading');
      var results = new Array(handles.length);
      var done = 0;
      handles.forEach(function (h, i) {
        fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (p) {
            results[i] = p;
            if (++done !== handles.length) return;
            var live = [];
            grid.innerHTML = '';
            results.forEach(function (p, idx) {
              if (!p) return;
              live.push(handles[idx]);
              grid.appendChild(card(p));
            });
            /* prune handles that no longer resolve */
            if (live.length !== handles.length) { wishSet(live); }
            if (!live.length) { show('empty'); return; }
            if (countEl) { countEl.textContent = live.length + (live.length === 1 ? ' piece saved' : ' pieces saved'); }
            show('list');
          });
      });
    }

    on(grid, 'click', function (e) {
      var rm = e.target.closest('[data-am-wish-remove]');
      if (rm) {
        var cardEl = rm.closest('.am-wish-card');
        var h = cardEl && cardEl.getAttribute('data-handle');
        if (!h) return;
        var list = wishGet();
        var i = list.indexOf(h);
        if (i > -1) { list.splice(i, 1); wishSet(list); }
        cardEl.remove();
        var left = grid.querySelectorAll('.am-wish-card').length;
        if (countEl) { countEl.textContent = left + (left === 1 ? ' piece saved' : ' pieces saved'); }
        if (!left) show('empty');
        amToast('Removed from wishlist');
        return;
      }
      var add = e.target.closest('[data-am-wish-add]');
      if (add) {
        var vid = add.getAttribute('data-vid');
        if (!vid) return;
        add.disabled = true;
        var label = add.textContent;
        add.textContent = 'Adding';
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function (r) { return r.json(); })
          .then(function () {
            add.disabled = false; add.textContent = label;
            updateCartCount();
            document.dispatchEvent(new CustomEvent('am:cart:open'));
            try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
        /* GoKwik listens for this name to rescan for checkout buttons */
        try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
          })
          .catch(function () { add.disabled = false; add.textContent = label; amToast('Could not add to bag'); });
      }
    });

    on(clearBtn, 'click', function () {
      wishSet([]);
      grid.innerHTML = '';
      show('empty');
      amToast('Wishlist cleared');
    });

    paint();
  }

  /* ---------------- quick add (cards) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-am-qadd]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var vid = btn.getAttribute('data-am-qadd');
    var after = btn.getAttribute('data-am-after') || 'toast';
    if (!vid) { return; }
    ajaxAdd([{ id: parseInt(vid, 10), quantity: 1 }], btn, after);
  });

  /* ---------------- announcement: ensure loop width ---------------- */
  function initAnnounce(sec) {
    var track = $('.am-ann-track', sec);
    if (!track) return;
    var group = $('.am-ann-group', track);
    if (!group) return;
    while (track.scrollWidth < window.innerWidth * 2 && track.children.length < 12) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
  }

  /* ---------------- header: mobile drawer ---------------- */
  /* ---------------- menu-item dropdowns ----------------
     The panel is anchored to .am-header rather than to its own trigger, so that
     the horizontally scrolling nav cannot clip it. That means its x position has
     to be worked out here: trigger left, measured against the header, clamped so
     a panel near the right edge does not run off screen. Recomputed on open, on
     nav scroll and on resize, because the trigger moves when the nav scrolls. */
  function initMenuDrops(sec) {
    var header = sec.querySelector('.am-header') || sec;
    var nav = sec.querySelector('.am-hdr-left');
    var wraps = $$('[data-am-drop]', sec);
    if (!wraps.length) return;

    function place(wrap) {
      var trigger = $('.am-drop-trigger', wrap);
      var panel = $('[data-am-drop-panel]', wrap);
      if (!trigger || !panel) return;
      var hr = header.getBoundingClientRect();
      var tr = trigger.getBoundingClientRect();
      var w = panel.offsetWidth || 216;
      var x = tr.left - hr.left;
      var maxX = hr.width - w - 12;
      if (x > maxX) { x = Math.max(12, maxX); }
      if (x < 0) { x = 0; }
      panel.style.setProperty('--am-drop-x', Math.round(x) + 'px');
    }
    function placeAll() { wraps.forEach(place); }

    /* The panel is positioned against the header, not the trigger, so it can sit
       well to one side of the link that opens it - on the last nav item it is
       clamped inward and ends up left of its trigger. Moving the cursor toward
       it then crosses a strip that is neither trigger nor panel, and a pure
       :hover rule drops the menu mid-travel. Hold it open briefly instead. */
    var dropTimer = null;
    function closeAll() { wraps.forEach(function (w) { w.classList.remove('is-open'); }); }
    function openOnly(wrap) {
      if (dropTimer) { clearTimeout(dropTimer); dropTimer = null; }
      wraps.forEach(function (w) { if (w !== wrap) w.classList.remove('is-open'); });
      wrap.classList.add('is-open');
      place(wrap);
    }
    function scheduleClose() {
      if (dropTimer) clearTimeout(dropTimer);
      dropTimer = setTimeout(closeAll, 260);
    }

    wraps.forEach(function (wrap) {
      on(wrap, 'pointerenter', function () { place(wrap); if (window.matchMedia('(hover:hover)').matches) openOnly(wrap); });
      on(wrap, 'pointerleave', function () { if (window.matchMedia('(hover:hover)').matches) scheduleClose(); });
      var pnl = $('[data-am-drop-panel]', wrap);
      on(pnl, 'pointerenter', function () { if (dropTimer) { clearTimeout(dropTimer); dropTimer = null; } });
      on(pnl, 'pointerleave', function () { if (window.matchMedia('(hover:hover)').matches) scheduleClose(); });
      on(wrap, 'focusin', function () { place(wrap); });
      /* touch: first tap opens, second follows the link */
      on($('.am-drop-trigger', wrap), 'click', function (e) {
        if (window.matchMedia('(hover:hover)').matches) return;
        if (!wrap.classList.contains('is-open')) {
          e.preventDefault();
          wraps.forEach(function (w2) { w2.classList.remove('is-open'); });
          wrap.classList.add('is-open');
          place(wrap);
        }
      });
    });
    on(document, 'click', function (e) {
      if (e.target.closest('[data-am-drop]')) return;
      wraps.forEach(function (w2) { w2.classList.remove('is-open'); });
    });
    if (nav) { on(nav, 'scroll', placeAll, { passive: true }); }
    on(window, 'resize', placeAll);
    placeAll();
  }

  function initHeader(sec) {
    /* Shopify wraps this section in <div id="shopify-section-am-header">. position:sticky
       on the inner .am-header-section does nothing because that wrapper is only header-
       height tall and scrolls away with it. So when sticky is enabled, promote the sticky
       to the wrapper itself - that is the real child of the scroll container. */
    if (sec.classList.contains('am-sticky') && sec.parentElement && sec.parentElement.id === 'shopify-section-am-header') {
      sec.parentElement.classList.add('am-sticky-wrap');
    }
    var open = $('[data-am-mnav-open]', sec);
    var drawer = $('.am-mnav', sec);
    var overlay = $('.am-mnav-overlay', sec);
    function lockScroll(on) {
      document.documentElement.style.overflow = on ? 'hidden' : '';
      document.body.style.overflow = on ? 'hidden' : '';
    }
    function close() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      /* reset all sub-panels to level 1 (state reset) */
      $$('[data-am-mnav-panel]', sec).forEach(function (p) {
        p.classList.remove('is-active', 'is-left');
        if (p.getAttribute('data-am-mnav-panel') === 'main') p.classList.add('is-active');
      });
      lockScroll(false);
    }
    on(open, 'click', function (e) {
      e.preventDefault();
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      lockScroll(true);
    });
    on(overlay, 'click', close);
    on($('[data-am-mnav-close]', sec), 'click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------------- mobile drawer multi-level nav ---------------- */
  function initDrawerNav(sec) {
    /* sub-menu groups: a link with children expands in place. Height is set in
       px so it can animate, then cleared to 'none' once open, otherwise a nested
       group expanding inside it would be clipped by the parent's fixed height. */
    $$('[data-am-mnav-group]', sec).forEach(function (group) {
      var btn = $('[data-am-mnav-toggle]', group);
      var panel = $('.am-mnav-sub', group);
      if (!btn || !panel || btn.__amMnav) return;
      btn.__amMnav = true;
      on(btn, 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = group.classList.contains('is-open');
        if (open) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.maxHeight = '0px'; });
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          setTimeout(function () { if (group.classList.contains('is-open')) panel.style.maxHeight = 'none'; }, 340);
        }
        group.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        /* a nested group changes its parent's height, so let the parent grow */
        var parent = group.parentElement && group.parentElement.closest('[data-am-mnav-group]');
        if (parent) {
          var pPanel = $('.am-mnav-sub', parent);
          if (pPanel && parent.classList.contains('is-open')) pPanel.style.maxHeight = 'none';
        }
      });
    });

    var tabs = $$('[data-am-tab]', sec);
    var panels = $$('[data-am-tabpanel]', sec);
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      on(tab, 'click', function () {
        var name = tab.getAttribute('data-am-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-am-tabpanel') === name);
        });
        var body = $('.am-mnav-body', sec);
        if (body) body.scrollTop = 0;
      });
    });
  }

  /* ---------------- scroll reveal (design system) ---------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    /* auto-tag common blocks that are not already tagged */
    var auto = [];
    $$('[data-am-collection] .am-tile, .am-prod-grid > *, .am-promise3-item, .am-si-in, [data-am-header] .am-sh, .am-coll .am-sh').forEach(function (el) {
      if (!el.hasAttribute('data-am-reveal')) { el.setAttribute('data-am-reveal', ''); auto.push(el); }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 40px 0px' });
    $$('[data-am-reveal]').forEach(function (el) { io.observe(el); });
    /* safety net: never leave content hidden */
    setTimeout(function () { $$('[data-am-reveal]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); }); }, 1500);
  }

  /* ---------------- quick view modal (item 11) ---------------- */
  /* Mirrors Liquid's `handle` filter so class names built here match the ones
     built in Liquid - bg_color_cool-yellow from both sides. */
  function amHandle(v) {
    return String(v || '').toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initQuickView() {
    var modal = $('[data-am-qv-modal]');
    var overlay = $('[data-am-qv-overlay]');
    if (!modal) return;
    var inner = $('[data-am-qv-inner]', modal);
    var cache = {};

    function open() { modal.classList.add('is-open'); overlay.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); overlay.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    on(overlay, 'click', close);
    on($('[data-am-qv-close]', modal), 'click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

    function money(cents) { return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

    function render(pr) {
      /* option names can come back as strings (["Size","Color"]) or as objects
         ([{name:"Size",...}]) depending on the endpoint - normalise to names. */
      var optNames = (pr.options || []).map(function (o) {
        return (typeof o === 'string') ? o : (o && o.name) || '';
      });
      var colorIdx = -1, sizeIdx = -1;
      optNames.forEach(function (o, i) {
        if (colorIdx === -1 && /colou?r|shade|colour/i.test(o)) colorIdx = i;
        if (sizeIdx === -1 && /size|fit/i.test(o)) sizeIdx = i;
      });
      /* if neither matched but the product has real options (not the single
         "Title" default), treat option 1 as size and option 2 as colour so the
         selectors always render in quick view. */
      var hasRealOpts = optNames.length && !(optNames.length === 1 && /^title$/i.test(optNames[0]));
      if (hasRealOpts && sizeIdx === -1 && colorIdx === -1) {
        sizeIdx = 0;
        if (optNames.length > 1) colorIdx = 1;
      }

      var featImg = (pr.featured_image) || (pr.images && pr.images[0]) || '';
      /* Gallery matches the product page: on phone the PDP shows every image as
         a full-width scroll-snap strip with dots, so quick view does the same
         rather than a single static photo. Desktop keeps the one large image -
         the extra cells are hidden by CSS there, so the markup is identical at
         both widths and only the styling differs. */
      var gimgs = (pr.images && pr.images.length ? pr.images : (featImg ? [featImg] : []));
      var html = '';
      html += '<div class="am-qv-media" data-am-qv-media>';
      html +=   '<div class="am-qv-gal" data-am-qv-gal>';
      gimgs.forEach(function (src, gi) {
        var full = (src.indexOf('//') === 0 ? 'https:' + src : src);
        html += '<figure class="am-qv-gcell" data-am-zoom>' +
                '<img ' + (gi === 0 ? 'data-am-qv-img ' : 'loading="lazy" ') +
                'src="' + full + '" alt="' + (pr.title || '').replace(/"/g, '&quot;') + '">' +
                '</figure>';
      });
      html +=   '</div>';
      if (gimgs.length > 1) {
        html += '<div class="am-qv-dots" data-am-qv-dots>';
        gimgs.forEach(function (s2, gi) { html += '<button type="button" class="am-qv-dot' + (gi === 0 ? ' is-on' : '') + '" aria-label="Image ' + (gi + 1) + '"></button>'; });
        html += '</div>';
        html += '<button type="button" class="am-gnav am-gnav--prev am-qv-gnav" data-am-qv-prev aria-label="Previous image"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>';
        html += '<button type="button" class="am-gnav am-gnav--next am-qv-gnav" data-am-qv-next aria-label="Next image"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg></button>';
      }
      html += '</div>';
      html += '<div class="am-qv-info">';
      var firstVar = pr.variants[0];
      var rts = firstVar.inventory_management ? (firstVar.inventory_quantity > 0) : true;
      html += '<span class="am-qv-tag" data-am-qv-tag><span class="am-sdot"></span><span>' + (rts ? 'Ready to Ship' : 'Made to Order') + '</span></span>';
      html += '<h2>' + pr.title + '</h2>';
      html += '<div class="am-qv-price" data-am-qv-price>' + money(firstVar.price) + (firstVar.compare_at_price > firstVar.price ? '<s>' + money(firstVar.compare_at_price) + '</s>' : '') + '</div>';
      if (pr.description) { html += '<div class="am-qv-desc">' + pr.description + '</div>'; }

      /* color swatches (variant images via option) */
      if (colorIdx > -1) {
        var seen = {};
        html += '<div class="am-qv-opt"><span class="am-qv-opt-label">' + optNames[colorIdx] + '</span><div class="am-qv-swatches">';
        pr.variants.forEach(function (v) {
          var cv = v.options[colorIdx];
          if (seen[cv]) return; seen[cv] = 1;
          var vi = v.featured_image ? v.featured_image.src : '';
          /* Colour came from taking the last word of the option value and using
             it as a CSS colour - Panna became background:panna, which is not a
             colour, so most swatches rendered empty. Use the same bg_color_
             class the product page and cards use, so the shade comes from the
             store's own Custom Color definitions. */
          html += '<button type="button" class="am-circle" data-am-qv-color="' + cv + '"' + (vi ? ' data-img="' + vi + '"' : '') + ' title="' + cv + '" aria-label="' + cv + '">' +
                    '<span class="am-circle-in bg_color_' + amHandle(cv) + '">' +
                      (vi ? '<img src="' + vi + '&width=70" alt="">' : '') +
                    '</span>' +
                  '</button>';
        });
        html += '</div></div>';
      }
      /* sizes */
      if (sizeIdx > -1) {
        html += '<div class="am-qv-opt"><span class="am-qv-opt-label">' + optNames[sizeIdx] + '</span><div class="am-qv-sizes">';
        var seenS = {};
        pr.variants.forEach(function (v) {
          var sv = v.options[sizeIdx];
          if (seenS[sv]) return; seenS[sv] = 1;
          /* same pill the product page uses, so the two read as one design */
          html += '<button type="button" class="am-tabpill" data-am-qv-size="' + sv + '" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + sv + '</button>';
        });
        html += '</div></div>';
      }
      /* A real product form inside the quick view. GoKwik resolves a buy
         button's variant with btn.closest("form"), so without one it found
         no variant context and fell back to its cart flow. closest() also
         means this never clashes with the product page's own form. */
      html += '<form action="/cart/add" method="post" enctype="multipart/form-data" class="am-buyform" data-am-product-form data-am-qv-form>';
      html += '<input type="hidden" name="id" data-am-qv-id value="' + firstVar.id + '">';
      html += '<input type="hidden" name="quantity" value="1">';
      html += '<div class="am-qv-buys"><button type="button" class="am-btn am-atc" data-am-qv-atc data-vid="' + firstVar.id + '">Add to Bag</button>';
      /* data-gokwik-processed keeps GoKwik off this button. It claims anything
         labelled "Buy It Now", but the quick view has no product form, so its
         buyNow flow found no variant context and dumped the shopper on the cart
         page. We add the item ourselves and hand over to a checkout link GoKwik
         has claimed, which is the path that works from the drawer. */
      html += '<button type="button" class="am-btn am-btn--outline am-buynow" data-am-qv-buy data-vid="' + firstVar.id + '">Buy It Now</button></div></form>';
      html += '<a class="am-qv-full" href="/products/' + pr.handle + '">View Full Details</a>';
      html += '</div>';
      inner.innerHTML = html;

      /* wire interactions */
      var selVid = firstVar.id;
      var mainImg = $('[data-am-qv-img]', inner);

      /* Track colour and size separately and resolve the variant from both.
         The colour buttons only ever swapped the photo, and each size pill
         carried the id of the first variant with that size - which is the
         first colour - so whatever colour was tapped, the bag received the
         first one. */
      var selColor = colorIdx > -1 ? firstVar.options[colorIdx] : null;
      var selSize  = sizeIdx  > -1 ? firstVar.options[sizeIdx]  : null;

      function qvVariant(color, size) {
        return pr.variants.filter(function (x) {
          if (colorIdx > -1 && color != null && x.options[colorIdx] !== color) return false;
          if (sizeIdx  > -1 && size  != null && x.options[sizeIdx]  !== size)  return false;
          return true;
        })[0] || null;
      }

      /* The photo for a colour: the variant's own image if it has one, else an
         image whose alt text names the colour - the same alt matching the
         product page uses, which is why it worked there and not here. */
      function qvColorImg(cv) {
        var v = qvVariant(cv, null);
        if (v && v.featured_image && v.featured_image.src) return v.featured_image.src;
        var needle = String(cv || '').toLowerCase();
        var media = pr.media || [];
        for (var i = 0; i < media.length; i++) {
          var alt = (media[i].alt || '').toLowerCase();
          if (alt && needle && alt.indexOf(needle) > -1 && media[i].src) return media[i].src;
        }
        return null;
      }

      function qvSync() {
        var v = qvVariant(selColor, selSize);
        if (!v) return;
        selVid = v.id;
        var qvId = $('[data-am-qv-id]', inner);
        if (qvId) qvId.value = selVid;
        var atcB = $('[data-am-qv-atc]', inner);
        if (atcB) atcB.setAttribute('data-vid', selVid);
        var buyB = $('[data-am-qv-buy]', inner);
        if (buyB) buyB.setAttribute('data-vid', selVid);

        var pEl = $('[data-am-qv-price]', inner);
        if (pEl) pEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
        var r = v.inventory_management ? (v.inventory_quantity > 0) : true;
        var tag = $('[data-am-qv-tag] span:last-child', inner);
        if (tag) tag.textContent = r ? 'Ready to Ship' : 'Made to Order';

        /* mark the colour the resolved variant actually is, so the opening
           state is not a set of swatches with none selected */
        if (colorIdx > -1) {
          $$('[data-am-qv-color]', inner).forEach(function (o) {
            o.classList.toggle('is-active', o.getAttribute('data-am-qv-color') === selColor);
          });
        }

        /* re-point the size pills at this colour, and grey out sizes it is
           not made in, so an unavailable pairing cannot be added */
        if (sizeIdx > -1) {
          $$('[data-am-qv-size]', inner).forEach(function (pill) {
            var sv = pill.getAttribute('data-am-qv-size');
            var pv = qvVariant(selColor, sv);
            if (pv) {
              pill.setAttribute('data-vid', pv.id);
              if (pv.available) pill.removeAttribute('disabled');
              else pill.setAttribute('disabled', 'disabled');
            } else {
              pill.setAttribute('disabled', 'disabled');
            }
            pill.classList.toggle('is-active', sv === selSize);
          });
        }
      }

      /* dots follow the strip, and tapping one scrolls to that image */
      var qvGal = $('[data-am-qv-gal]', inner);
      var qvDots = $$('[data-am-qv-dots] .am-qv-dot', inner);
      if (qvGal && qvDots.length) {
        qvDots.forEach(function (d, di) {
          on(d, 'click', function () { qvGal.scrollTo({ left: di * qvGal.clientWidth, behavior: 'smooth' }); });
        });
        on(qvGal, 'scroll', function () {
          var i = Math.round(qvGal.scrollLeft / (qvGal.clientWidth || 1));
          qvDots.forEach(function (d, di) { d.classList.toggle('is-on', di === i); });
        }, { passive: true });
      }
      /* prev/next arrows, matching the product page gallery */
      if (qvGal) {
        function qvGo(step) {
          var w = qvGal.clientWidth || 1;
          var i = Math.round(qvGal.scrollLeft / w) + step;
          var last = qvGal.children.length - 1;
          if (i < 0) i = last;
          if (i > last) i = 0;
          qvGal.scrollTo({ left: i * w, behavior: 'smooth' });
        }
        var qvPrev = $('[data-am-qv-prev]', inner);
        var qvNext = $('[data-am-qv-next]', inner);
        if (qvPrev) on(qvPrev, 'click', function (e) { e.preventDefault(); e.stopPropagation(); qvGo(-1); });
        if (qvNext) on(qvNext, 'click', function (e) { e.preventDefault(); e.stopPropagation(); qvGo(1); });
      }
      initZoom(inner);
      $$('[data-am-qv-color]', inner).forEach(function (sw) {
        on(sw, 'click', function () {
          $$('[data-am-qv-color]', inner).forEach(function (o) { o.classList.toggle('is-active', o === sw); });
          selColor = sw.getAttribute('data-am-qv-color');
          qvSync();
          var img = sw.getAttribute('data-img') || qvColorImg(selColor);
          if (img && mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.src = img;
            /* the swapped photo is the first cell, so bring the strip back
               to it - otherwise the colour changes off-screen */
            if (qvGal) qvGal.scrollTo({ left: 0, behavior: 'smooth' });
          }
        });
      });
      qvSync();
      $$('[data-am-qv-size]', inner).forEach(function (sz) {
        on(sz, 'click', function () {
          if (sz.hasAttribute('disabled')) return;
          selSize = sz.getAttribute('data-am-qv-size');
          /* qvSync resolves the variant from colour AND size, updates the
             form, the buttons, the price and the stock line */
          qvSync();
        });
      });
      on($('[data-am-qv-atc]', inner), 'click', function () { ajaxAdd([{ id: parseInt(selVid, 10), quantity: 1 }], this, 'drawer'); });
      on($('[data-am-qv-buy]', inner), 'click', function () {
        var btn = this;
        /* GoKwik marks the buttons it owns. When it has claimed this one it
           runs its own buy-now flow off the form above, so doing our own add
           here as well would put the item in the bag twice. For an
           international shopper GoKwik never attaches, nothing is marked, and
           this falls through to the plain add-then-checkout below. */
        if (btn.hasAttribute('data-gokwik-processed')) return;
        if (btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        ajaxAdd([{ id: parseInt(selVid, 10), quantity: 1 }], btn, 'none').then(function (res) {
          /* ajaxAdd swallows its own errors and resolves undefined; without
             this a failed add still sent the shopper to checkout with an
             empty bag. The toast has already said what went wrong. */
          if (!res) { btn.disabled = false; btn.classList.remove('is-loading'); return; }
          amCheckoutHandoff();
        });
      });
    }

    /* Delegated from the document rather than bound to each button at boot.
       The old version attached listeners once to the buttons that happened to
       exist at page load, so every card rendered afterwards - filtering, sort,
       pagination, a section reloaded in the editor, anything AJAX - produced a
       quick view button with no handler on it at all. Delegation covers cards
       that do not exist yet. Guarded so it can only ever be attached once. */
    if (!document.__amQVBound) {
      document.__amQVBound = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-am-qv]') : null;
        if (!btn) return;
        e.preventDefault(); e.stopPropagation();
        var handle = btn.getAttribute('data-am-qv');
        if (!handle) return;
        open();
        inner.innerHTML = '<div class="am-qv-loading"><span class="am-qv-spin"></span></div>';
        if (cache[handle]) { render(cache[handle]); return; }
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (pr) { cache[handle] = pr; render(pr); })
          .catch(function (err) {
            if (window.console && console.error) { console.error('[AM] quick view failed for ' + handle, err); }
            inner.innerHTML = '<div class="am-qv-loading">Could not load. <a href="/products/' + handle + '">Open product page</a></div>';
          });
      });
    }
  }

  /* ---------------- collection circular slider ---------------- */
  function initCircNav() {
    /* drag-to-scroll for a natively scrollable strip (arrow mode) */
    function enableDragScroll(el) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      /* Touch already scrolls this natively - the element is overflow-x:auto -
         and native scrolling has momentum that a JS drag does not. Mouse is the
         only pointer that needs help, so leave touch and pen alone. */
      on(el, 'pointerdown', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startScroll = el.scrollLeft;
        el.classList.add('is-grabbing');
      });
      on(el, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 8) {
          /* Only now is this a drag rather than a click, so only now is it
             safe to make the circles click-through. */
          if (!moved) el.classList.add('is-dragging');
          moved = true;
        }
        if (moved) el.scrollLeft = startScroll - dx;
      });
      function end() {
        down = false;
        el.classList.remove('is-grabbing');
        el.classList.remove('is-dragging');
      }
      on(el, 'pointerup', end);
      on(el, 'pointercancel', end);
      on(el, 'pointerleave', end);
      /* swallow click ONLY when the user actually dragged; reset immediately
         after so the next genuine click on a circle navigates normally. */
      on(el, 'click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
        moved = false;
      }, true);
    }

    /* swipe support for loop (marquee) mode: pause the animation and let the user
       drag through the circles; resume shortly after they let go */
    function enableCircSwipe(nav, track) {
      var down = false, startX = 0, baseX = 0, curX = 0, moved = false, resumeT;
      function currentTranslate() {
        var m = getComputedStyle(track).transform;
        if (!m || m === 'none') return 0;
        var vals = m.match(/matrix.*\((.+)\)/);
        if (!vals) return 0;
        var parts = vals[1].split(', ');
        return parseFloat(parts[4]) || 0;
      }
      var startY = 0, axis = '';
      on(nav, 'pointerdown', function (e) {
        down = true; moved = false; axis = '';
        startX = e.clientX; startY = e.clientY;
        baseX = currentTranslate();
        track.style.animationPlayState = 'paused';
        nav.classList.add('is-grabbing');
        clearTimeout(resumeT);
      });
      on(nav, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        /* Decide the axis on the first meaningful movement. A thumb swipe
           across the circles is never perfectly horizontal, and touch-action
           pan-y lets the browser claim anything with a vertical component -
           it then fires pointercancel and the drag died before it started,
           which is why this could not be swiped on a phone. Claiming the
           pointer once the gesture is clearly horizontal keeps the events
           coming here; a vertical gesture is released so the page scrolls. */
        if (!axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x') {
            try { nav.setPointerCapture(e.pointerId); } catch (err) {}
          } else {
            down = false;
            nav.classList.remove('is-grabbing');
            track.style.animationPlayState = '';
            return;
          }
        }
        if (axis !== 'x') return;
        if (e.cancelable) e.preventDefault();
        if (Math.abs(dx) > 8) moved = true;   /* only count a real drag */
        if (moved) { curX = baseX + dx; track.style.transform = 'translateX(' + curX + 'px)'; }
      });
      function end() {
        if (!down) return;
        down = false;
        axis = '';
        nav.classList.remove('is-grabbing');
        /* Once someone has actually dragged, leave the row where they put it.
           Clearing the transform snapped it back to wherever the animation had
           reached, which read as the swipe not having worked at all. If they
           only tapped, the marquee carries on. */
        if (moved) {
          track.style.animation = 'none';
          return;
        }
        resumeT = setTimeout(function () {
          track.style.transform = '';
          track.style.animationPlayState = '';
        }, 1600);
      }
      /* On pointerup, if the user did NOT drag, navigate manually.
         In marquee mode the track is CSS-animating, so the element moves
         between pointerdown and pointerup and the browser fires no click
         at all (the hit target changed). Driving navigation ourselves is
         what makes the circles actually open their collection. */
      on(nav, 'pointerup', function (e) {
        var wasDrag = moved;
        end();
        if (wasDrag) return;
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a) {
          /* the moving element may have shifted out from under the finger -
             fall back to whatever link sits at the release point */
          var el = document.elementFromPoint(e.clientX, e.clientY);
          a = el && el.closest ? el.closest('a[href]') : null;
        }
        if (a && nav.contains(a) && !e.metaKey && !e.ctrlKey && e.button !== 1) {
          e.preventDefault();
          window.location.href = a.getAttribute('href');
        }
      });
      on(nav, 'pointercancel', end);
      /* no pointerleave here: with the pointer captured, a finger crossing the
         edge of the row would otherwise abort a drag that is still in progress */
      /* swallow the synthetic click only when it followed a real drag */
      on(nav, 'click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
        moved = false;
      }, true);
    }

    $$('[data-am-circnav]').forEach(function (nav) {
      if (nav.hasAttribute('data-am-circnav-loop')) {
        /* wrap children in a track, duplicate for seamless loop */
        var items = Array.prototype.slice.call(nav.children);
        var track = document.createElement('div');
        track.className = 'am-circnav-track';
        items.forEach(function (n) { track.appendChild(n); });
        items.forEach(function (n) { track.appendChild(n.cloneNode(true)); });
        nav.appendChild(track);
        var dur = parseInt(nav.getAttribute('data-speed'), 10) || 35;
        nav.style.setProperty('--am-circ-dur', dur + 's');
        /* hide arrows in loop mode */
        var wrap = nav.closest('.am-circnav-wrap');
        if (wrap) $$('.am-circ-arrow', wrap).forEach(function (a) { a.style.display = 'none'; });
        enableCircSwipe(nav, track);
        return;
      }
      /* arrow scroll mode */
      var wrap = nav.closest('.am-circnav-wrap');
      if (!wrap) return;
      var prev = $('[data-am-circ-prev]', wrap);
      var next = $('[data-am-circ-next]', wrap);
      on(prev, 'click', function () { nav.scrollBy({ left: -240, behavior: 'smooth' }); });
      on(next, 'click', function () { nav.scrollBy({ left: 240, behavior: 'smooth' }); });
      enableDragScroll(nav);
    });
  }

  /* ---------------- image zoom (PDP + quick view) ---------------- */
  var amZoomLb = null;
  function ensureZoomLb() {
    if (amZoomLb) return amZoomLb;
    amZoomLb = document.createElement('div');
    amZoomLb.className = 'am-zoom-lb';
    amZoomLb.innerHTML = '<button type="button" class="am-zoom-lb-close" aria-label="Close">&times;</button><img alt="">';
    document.body.appendChild(amZoomLb);
    var img = amZoomLb.querySelector('img');
    function close() { amZoomLb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    on(amZoomLb, 'click', function (e) { if (e.target !== img) close(); });
    on(amZoomLb.querySelector('.am-zoom-lb-close'), 'click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    amZoomLb._open = function (src) { img.src = src; amZoomLb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
    return amZoomLb;
  }
  function initZoom(root) {
    $$('[data-am-zoom]', root || document).forEach(function (cell) {
      var img = cell.querySelector('img');
      if (!img) return;
      /* hover pan: move transform-origin with cursor */
      on(cell, 'mousemove', function (e) {
        var r = cell.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      on(cell, 'mouseleave', function () { img.style.transformOrigin = 'center center'; });
      /* click -> lightbox */
      on(cell, 'click', function () {
        var full = (img.currentSrc || img.src).split('&width=')[0].split('?')[0];
        var src = img.currentSrc || img.src;
        ensureZoomLb()._open(src);
      });
    });
  }

  /* ---------------- product card carousel + variants ---------------- */

  /* ----------------------------------------------------------------
     A card's stock state - rts, mto or sold - from its own variant
     data. The card snippet also writes it as data-am-stock, but every
     card already carries its variants' quantities and availability,
     so reading them here means the filter and the Made to Order label
     hold even when an older copy of the snippet is being served.
  ---------------------------------------------------------------- */

  /* Values that sit in a size option but are not a size anyone picks:
     made-to-measure options, and "Without Pant" style bottoms on a set whose
     bottom-size option is the one named "size". */
  var AM_SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL'];
  function amIsRealSize(x) {
    var u = String(x || '').toUpperCase().trim();
    return !!u && u.indexOf('CUSTOM') === -1 && u.indexOf('SEMI') === -1 &&
           u.indexOf('STITCH') === -1 && u.indexOf('WITHOUT') === -1;
  }
  function amSortSizes(list) {
    return list.slice().sort(function (a, b) {
      var ia = AM_SIZE_ORDER.indexOf(a), ib = AM_SIZE_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
  }

  function cardStockState(card) {
    var s0 = card.getAttribute('data-am-stock');
    if (s0 === 'rts' || s0 === 'mto' || s0 === 'sold') return s0;
    var el = card.querySelector('[data-am-card-variants]');
    var list = [];
    try { list = JSON.parse(el ? el.textContent : '[]'); } catch (e) { list = []; }
    var units = false, orderable = false;
    list.forEach(function (v) {
      if ((v.qty || 0) > 0) units = true;
      if (v.available) orderable = true;
    });
    var st = units ? 'rts' : (orderable ? 'mto' : 'sold');
    card.setAttribute('data-am-stock', st);
    return st;
  }

  function setPillText(tag, text) {
    if (tag.firstChild && tag.firstChild.nodeType === 3) {
      tag.firstChild.nodeValue = text;
    } else {
      tag.insertBefore(document.createTextNode(text), tag.firstChild);
    }
  }

  function initProductCards(root) {
    $$('[data-am-card]', root || document).forEach(function (card) {
      /* The stock pill belongs under the photograph, just above the title.
         An older copy of this card's markup still places it inside the image
         box, where the box's overflow clips it. Moving it here makes the card
         right whichever copy is being served, and it happens first so the
         size fitter measures the pill in its final position. */
      var stockTag = $('[data-am-invtag]', card);
      var cardTitle = $('.am-card-title', card);
      if (stockTag && cardTitle && stockTag.parentNode !== cardTitle.parentNode) {
        cardTitle.parentNode.insertBefore(stockTag, cardTitle);
      }
      /* With no units on the shelf, a piece that still takes orders shows its
         card label if it has one, otherwise Made to Order. Worked out from the
         card's own data, so it does not depend on which snippet is served. */
      var cardState = cardStockState(card);
      /* Units on the shelf but the pill is hidden: the older snippet still
         being served drops stock held only on Semi-Stitch, and anything on a
         product past fifty variants. Show it from the card's own data -
         Ready to Ship with its real sizes, or on its own when the only units
         are Semi-Stitch. */
      if (stockTag && cardState === 'rts' && stockTag.hidden) {
        var vlist = [];
        try { vlist = JSON.parse(card.querySelector('[data-am-card-variants]').textContent); } catch (e) { vlist = []; }
        var have = [];
        vlist.forEach(function (v) {
          if ((v.qty || 0) <= 0) return;
          var sz = String(v.size || '').toUpperCase().trim();
          if (amIsRealSize(sz) && have.indexOf(sz) === -1) have.push(sz);
        });
        have = amSortSizes(have);
        setPillText(stockTag, 'Ready to Ship');
        var szShow = $('.am-card-stock-sz', stockTag);
        if (!szShow && have.length) {
          szShow = document.createElement('span');
          szShow.className = 'am-card-stock-sz';
          stockTag.appendChild(szShow);
        }
        if (szShow) {
          szShow.textContent = have.length ? ': ' + have.join(', ') : '';
          szShow.hidden = !have.length;
        }
        /* the size fitter paints from this list, so it must hold the same
           sizes or its first pass would wipe them */
        stockTag.__amSizes = have.slice();
        stockTag.setAttribute('data-state', 'rts');
        stockTag.hidden = false;
      }
      if (stockTag && cardState === 'mto' && stockTag.getAttribute('data-state') !== 'rts') {
        var ownLabel = stockTag.getAttribute('data-am-card-label') || '';
        setPillText(stockTag, ownLabel || 'Made to Order');
        stockTag.setAttribute('data-state', ownLabel ? 'label' : 'mto');
        var szHide = $('.am-card-stock-sz', stockTag);
        if (szHide) szHide.textContent = '';
        stockTag.hidden = false;
      }
      var all = $$('.am-card-slide', card);
      var dotWrap = $('[data-am-card-dots]', card);
      var dots = dotWrap ? $$('span', dotWrap) : [];
      var idx = 0, timer = null;

      /* The card holds every colour's photographs, tagged with data-c. Only
         one colour's set is in play at a time; the rest stay in the DOM so
         switching colour costs nothing. Untagged photos are the shared set,
         used by products with no colour option and as the opening view. */
      var slides = all.filter(function (s) { return !s.classList.contains('am-card-slide--off'); });
      if (!slides.length && all.length) {
        /* A colour with no photographs of its own would otherwise hide every
           slide and leave the card blank. Fall back to the first available. */
        all[0].classList.remove('am-card-slide--off');
        slides = [all[0]];
      }

      /* Five dots at most, however many photographs the colour has. A strip of
         twenty is clutter and none of them is big enough to aim at. Every image
         is still reachable by swiping or the arrows; the dots read as progress
         through the set rather than one marker per photo. */
      var DOT_MAX = 5;
      function setDots(n) {
        if (!dotWrap) return;
        var want = Math.min(n, DOT_MAX);
        if (dots.length !== want) {
          dotWrap.innerHTML = '';
          for (var i = 0; i < want; i++) dotWrap.appendChild(document.createElement('span'));
          dots = $$('span', dotWrap);
        }
        dotWrap.style.display = n > 1 ? '' : 'none';
      }

      function markDot(i, n) {
        if (!dots.length) return;
        /* spread the position across however many dots there are */
        var d = (n <= dots.length) ? i
              : Math.round(i / (n - 1) * (dots.length - 1));
        dots.forEach(function (x, k) { x.classList.toggle('is-active', k === d); });
      }

      /* Pull a colour's photographs into the browser cache before they are
         asked for, so choosing a colour shows them immediately rather than
         after a fetch. Called on hover and on touch, well ahead of the tap. */
      function warm(colour) {
        for (var i = 0; i < all.length; i++) {
          var s = all[i];
          if ((s.getAttribute('data-c') || '') !== colour) continue;
          if (s.__amWarm) continue;
          s.__amWarm = true;
          s.setAttribute('loading', 'eager');
          if (s.getAttribute('src')) {
            var pre = new Image();
            if (s.getAttribute('srcset')) pre.srcset = s.getAttribute('srcset');
            if (s.getAttribute('sizes')) pre.sizes = s.getAttribute('sizes');
            pre.src = s.getAttribute('src');
          }
        }
      }
      card.__amWarm = warm;

      card.__amSetColour = function (colour) {
        var next = all.filter(function (s) { return (s.getAttribute('data-c') || '') === colour; });
        if (!next.length) return false;
        warm(colour);
        all.forEach(function (s) {
          var on = next.indexOf(s) !== -1;
          s.classList.toggle('am-card-slide--off', !on);
          if (!on) s.classList.remove('is-active');
        });
        slides = next;
        setDots(slides.length);
        show(0);
        return true;
      };

      function show(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        markDot(idx, slides.length);
      }
      setDots(slides.length);
      function next() { show(idx + 1); }
      function prev() { show(idx - 1); }
      function start() { if (slides.length > 1 && !timer) timer = setInterval(next, 3000); }
      function stop() { clearInterval(timer); timer = null; }
      function restart() { stop(); start(); }
      /* Bind the controls whichever colour is showing. Gating on the opening
         slide count meant a card that started on a single photo never got its
         arrows, swipe or auto-rotate - and it could not gain them later when a
         colour with several photographs was chosen. next/prev are harmless on
         a single slide, since show() wraps on one index. */
      if (all.length > 1) {
        on($('[data-am-card-next]', card), 'click', function (e) { e.preventDefault(); e.stopPropagation(); next(); restart(); });
        on($('[data-am-card-prev]', card), 'click', function (e) { e.preventDefault(); e.stopPropagation(); prev(); restart(); });
        /* auto-rotate every 3s, only while hovered/visible to save cycles */
        var imgWrap = $('.am-card-img', card);
        on(imgWrap, 'mouseenter', start);
        on(imgWrap, 'mouseleave', stop);
        /* swipe */
        var x0 = null;
        on(imgWrap, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        on(imgWrap, 'touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          /* If the card sits in a slider that is being dragged, the swipe was
             meant for the row - paging this card's photos as well would move
             two things at once from one gesture. */
          var inTrack = card.closest ? card.closest('[data-am-ps-track]') : null;
          var rowDragging = inTrack && inTrack.__amDragging;
          if (!rowDragging && Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
          x0 = null;
        }, { passive: true });
        /* start rotating when scrolled into view */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (ents) {
            ents.forEach(function (en) { en.isIntersecting ? start() : stop(); });
          }, { threshold: 0.4 }).observe(card);
        }
      }

      /* variant swatch -> swap main image + inventory tag (items 4 + 12) */
      var variants = [];
      var vjson = $('[data-am-card-variants]', card);
      if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch (e) {} }
      var tag = $('[data-am-invtag]', card);
      var sws = $$('[data-am-sw]', card);
      /* Warm a colour's photographs the moment the cursor or finger arrives on
         its swatch. By the time the tap lands they are in cache, so the switch
         is immediate. Touch fires well before the click, which is the case
         that mattered - a phone has no hover to lean on. */
      $$('[data-am-sw]', card).forEach(function (sw) {
        var ch = (sw.getAttribute('data-am-sw-value') || '').toLowerCase().trim()
                 .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        if (!ch) return;
        var fire = function () { if (typeof card.__amWarm === 'function') card.__amWarm(ch); };
        on(sw, 'pointerenter', fire);
        on(sw, 'touchstart', fire, { passive: true });
      });

      /* seed the size list from what Liquid rendered, then trim it to the card.
         Parsing it back is what lets the same routine handle the load state and
         a colour change without two different code paths. */
      if (tag) {
        var szSeed = $('.am-card-stock-sz', tag);
        if (szSeed && !szSeed.hidden) {
          var raw = szSeed.textContent.replace(/^:\s*/, '').replace(/\s*\+\d+\s*more\s*$/, '');
          tag.__amSizes = raw.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
          fitStockSizes(tag);
          /* the card is narrower in a five-up grid than a three-up one and the
             grid reflows on resize, so refit rather than trusting the width the
             card happened to have when this first ran */
          if (window.ResizeObserver) {
            try {
              new ResizeObserver(function () { fitStockSizes(tag); }).observe(card);
            } catch (e) {}
          } else {
            window.addEventListener('resize', function () { fitStockSizes(tag); });
          }
        }
      }

      function applySwatch(sw) {
        var val = sw.getAttribute('data-am-sw-value');
        var img = sw.getAttribute('data-am-sw-img');
        /* Show every photograph of the chosen colour, not just one. The card
           already holds them all, so this is a class swap rather than a fetch
           and there is nothing to wait for. Falls back to the old behaviour -
           jump to a matching slide, or swap slide 0 - for products whose
           photos were never tagged with a colour. */
        var handled = false;
        if (typeof card.__amSetColour === 'function') {
          var ch = (val || '').toString().toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          handled = card.__amSetColour(ch);
          if (handled && typeof stop === 'function') stop();
        }
        if (!handled && slides.length) {
          if (typeof stop === 'function') stop();
          /* Jump to the gallery photo whose ALT names this colour, rather than
             overwriting slide 0 - overwriting lost the original photo and left
             the other slides showing the previous colour. Whole-word match
             first so "Red" does not land on the "Dark Red" photo. */
          var vdc = (val || '').toLowerCase().trim();
          var esc = vdc.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          var word = new RegExp('(^|[^a-z0-9])' + esc + '([^a-z0-9]|$)', 'i');
          var hit = -1, loose = -1;
          /* Exact first: the ALTs are written 'Color_Pearl White', so strip the
             marker and compare. Without this, picking "White" could land on the
             "Pearl White" photo, since a word match is happy with either. */
          for (var xi = 0; xi < slides.length; xi++) {
            var xa = (slides[xi].getAttribute('alt') || '').toLowerCase();
            var mk = xa.replace(/^.*colou?r\s*[_:\-]\s*/, '').trim();
            if (mk && vdc && mk === vdc) { hit = xi; break; }
          }
          for (var si = 0; hit === -1 && si < slides.length; si++) {
            var a = (slides[si].getAttribute('alt') || '').toLowerCase();
            if (!a || !vdc) continue;
            if (word.test(a)) { hit = si; break; }
            if (loose === -1 && a.indexOf(vdc) !== -1) loose = si;
          }
          if (hit === -1) hit = loose;
          if (hit >= 0) {
            show(hit);
          } else if (img) {
            /* No photo tagged with this colour - fall back to swapping slide 0,
               but keep its original source so the next click can restore it. */
            var first = slides[0];
            if (first.__amOrig === undefined) {
              first.__amOrig = { src: first.src, srcset: first.getAttribute('srcset') || '' };
            }
            slides.forEach(function (s) { s.classList.remove('is-active'); });
            first.setAttribute('srcset', '');
            first.removeAttribute('data-srcset');
            first.src = img;
            first.classList.add('is-active');
            idx = 0;
          }
        }
        /* Stock line reflects the chosen colour. This used to overwrite the
           whole tag with a flat label, which wiped the list of available sizes
           rendered into it - the sizes were correct on load and disappeared the
           moment a colour was clicked. Rebuild the list for the chosen colour
           instead, so it answers what is in stock in THAT colour. */
        if (tag) {
          var forColour = variants.filter(function (v) {
            return v.color === val || v.opt2 === val || v.opt3 === val;
          });
          if (forColour.length) {
            /* the size is whichever option is not the colour that was clicked */
            /* same rule as the Liquid render: real inventory, not availability,
               since continue-selling keeps available true at zero stock.
               Past 50 variants on a page Shopify stops returning real
               quantities and every qty arrives as 0, so the card is marked
               untrusted and this falls back to available rather than
               declaring the whole grid Made to Order. */
            var invUntrusted = tag.hasAttribute('data-am-inv-untrusted');
            function inStock(v) {
              /* Ready to Ship is stock on the shelf and nothing else, the same
                 rule the Liquid uses. Zero inventory never qualifies, whatever
                 the selling policy, and untracked variants have no count. */
              if (invUntrusted || !v.managed) return false;
              return v.qty > 0;
            }
            var sizes = [];
            /* same exclusions as the Liquid: made-to-measure options are not
               sizes anyone is choosing between */
            function isRealSize(x) { return amIsRealSize(x); }
            forColour.forEach(function (v) {
              if (!inStock(v)) return;
              /* Liquid names the size option per variant. Falling back to
                 "whichever option is not the colour" listed a third option's
                 value - Without Pant on a kurta set - as though it were a size. */
              var sz = v.size;
              if (!sz) { sz = (v.color === val) ? (v.opt2 || v.opt3) : v.color; }
              sz = (sz || '').toString().trim();
              sz = (sz || '').toUpperCase();
              if (!isRealSize(sz)) return;
              if (sizes.indexOf(sz) === -1) sizes.push(sz);
            });
            var anyAvail = forColour.some(inStock);
            var szEl = $('.am-card-stock-sz', tag);
            var cap = parseInt(tag.getAttribute('data-am-size-cap') || '6', 10);

            /* rewrite only the label text node, leaving the sizes span in place */
            /* Real stock takes the pill. With none, the product's own card
               label fills it if one is set, otherwise the pill is hidden -
               the Sold Out badge already covers a piece that cannot be
               ordered at all. */
            /* Same order as the Liquid: stock, then the product's own card
               label, then Made to Order while the piece still takes orders.
               Whether it takes orders is a property of the product, read from
               the card, so a colour with no units still reads Made to Order. */
            var cardLabel = tag.getAttribute('data-am-card-label') || '';
            var orderable = card.getAttribute('data-am-stock') !== 'sold';
            var label;
            if (anyAvail) {
              tag.setAttribute('data-state', 'rts');
              tag.hidden = false;
              label = 'Ready to Ship';
            } else if (cardLabel) {
              tag.setAttribute('data-state', 'label');
              tag.hidden = false;
              label = cardLabel;
            } else if (orderable) {
              tag.setAttribute('data-state', 'mto');
              tag.hidden = false;
              label = 'Made to Order';
            } else {
              tag.setAttribute('data-state', 'oos');
              tag.hidden = true;
              label = '';
            }
            if (tag.firstChild && tag.firstChild.nodeType === 3) {
              tag.firstChild.nodeValue = label;
            } else {
              tag.insertBefore(document.createTextNode(label), tag.firstChild);
            }
            if (szEl) {
              if (anyAvail && sizes.length) {
                tag.__amSizes = sizes.slice(0, cap);
                szEl.hidden = false;
                fitStockSizes(tag);
              } else {
                tag.__amSizes = [];
                szEl.textContent = '';
                szEl.hidden = true;
              }
            }
          }
        }
      }

      sws.forEach(function (sw) {
        on(sw, 'click', function (e) {
          e.preventDefault(); e.stopPropagation();
          sws.forEach(function (o) { o.classList.toggle('is-active', o === sw); });
          applySwatch(sw);
        });
        /* desktop: preview the colour on hover too */
        on(sw, 'mouseenter', function () {
          if (window.matchMedia && window.matchMedia('(hover:hover)').matches) applySwatch(sw);
        });
      });
    });
  }

  /* ---------------- promise band scroll draw ---------------- */
  function initPromiseDraw() {
    var secs = $$('[data-am-promise]');
    if (!secs.length || !('IntersectionObserver' in window)) {
      secs.forEach(function (s) { s.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    secs.forEach(function (s) { io.observe(s); });
  }

  /* ---------------- search drawer + predictive ---------------- */
  function initSearchDrawer() {
    var drawer = $('[data-am-search-drawer]');
    var overlay = $('[data-am-search-overlay]');
    if (!drawer) return;
    var input = $('[data-am-search-input]', drawer);
    var results = $('[data-am-search-results]', drawer);
    var deflt = $('[data-am-search-default]', drawer);
    function open() {
      drawer.classList.add('is-open'); overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 380);
    }
    function close() {
      drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
    $$('[data-am-search-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); open(); }); });
    on($('[data-am-search-close]', drawer), 'click', close);
    on(overlay, 'click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    /* predictive search via Shopify suggest API */
    var timer = null;
    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; deflt.hidden = false; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data.resources && data.resources.results) || {};
            var prods = res.products || [];
            var colls = res.collections || [];
            var html = '';
            if (colls.length) {
              html += '<span class="am-search-h">Collections</span><div class="am-search-colls">';
              colls.forEach(function (c) { html += '<a class="am-search-chip" href="' + c.url + '">' + c.title + '</a>'; });
              html += '</div>';
            }
            if (prods.length) {
              html += '<span class="am-search-h">Pieces</span><div class="am-search-prods">';
              prods.forEach(function (pr) {
                var img = pr.featured_image && pr.featured_image.url ? pr.featured_image.url : (pr.image || '');
                html += '<a class="am-search-pcard" href="' + pr.url + '"><span class="am-search-pimg">' + (img ? '<img src="' + img + '&width=220" alt="" loading="lazy">' : '') + '</span><span class="am-search-pt"><b>' + pr.title + '</b>' + (pr.price ? '<em>Rs. ' + pr.price + '</em>' : '') + '</span></a>';
              });
              html += '</div>';
            }
            if (!html) html = '<p class="am-search-empty">No matches - press Enter to search everything.</p>';
            results.innerHTML = html;
            results.hidden = false; deflt.hidden = true;
          })
          .catch(function () { results.hidden = true; deflt.hidden = false; });
      }, 220);
    });
  }

  /* ---------------- product slider arrows ---------------- */
  function initPSlider(root) {
    $$('[data-am-pslider]', root || document).forEach(function (wrap) {
      var track = $('[data-am-ps-track]', wrap);
      var prev = $('[data-am-ps-prev]', wrap);
      var next = $('[data-am-ps-next]', wrap);
      if (!track) return;
      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 24 : 300;
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      on(prev, 'click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      on(track, 'scroll', update);

      /* Drag to move the row. The track scrolls natively under a finger, but a
         card's own image gallery also listens for horizontal swipes and would
         claim the gesture, so a swipe often paged the product's photos instead
         of the row. Claiming it here and marking the drag lets the gallery
         stand down. There is no mouse equivalent of a swipe either, so this is
         also how the row moves on desktop without the arrows. */
      var down = false, moved = false, startX = 0, startY = 0, startLeft = 0;
      var isTouch = false, rafId = 0, wantLeft = 0;

      on(track, 'pointerdown', function (e) {
        if (e.button === 1 || e.button === 2) return;
        down = true; moved = false;
        isTouch = e.pointerType && e.pointerType !== 'mouse';
        startX = e.clientX; startY = e.clientY;
        startLeft = track.scrollLeft;
        track.__amDragging = false;
      });

      on(track, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        /* 8px before it counts as a drag, so a slightly unsteady tap still
           opens the product rather than nudging the row */
        if (!moved) {
          if (Math.abs(dx) <= 8) return;
          if (isTouch && Math.abs(dy) > Math.abs(dx)) { down = false; return; }
          moved = true;
          track.__amDragging = true;
          if (!isTouch) {
            track.style.scrollBehavior = 'auto';
            track.classList.add('is-dragging');
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
        }

        /* On a finger the browser is already scrolling this row, and it does it
           with momentum that a JS drag cannot reproduce. Writing scrollLeft as
           well moved the row twice per gesture, which is what made it feel
           jumpy. Touch only sets the dragging flag, so the card's own gallery
           stands down and lets the row take the swipe; the movement is native.
           A mouse has no such scrolling, so it still drives the row directly -
           batched into a frame rather than written on every event. */
        if (moved && !isTouch) {
          wantLeft = startLeft - dx;
          if (!rafId) {
            rafId = window.requestAnimationFrame(function () {
              rafId = 0;
              track.scrollLeft = wantLeft;
            });
          }
          e.preventDefault();
        }
      });

      function endDrag() {
        if (!down) return;
        down = false;
        if (rafId) { window.cancelAnimationFrame(rafId); rafId = 0; }
        track.style.scrollBehavior = '';
        track.classList.remove('is-dragging');
        /* cleared a tick later so the click that follows the release can still
           be suppressed before the flag goes */
        setTimeout(function () { track.__amDragging = false; }, 0);
      }
      on(track, 'pointerup', endDrag);
      on(track, 'pointercancel', endDrag);
      /* no pointerleave: with the pointer captured, the cursor crossing the
         edge of the row would otherwise stop a drag that is still going */

      /* a drag must not open whichever card it finished on */
      on(track, 'click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      update();
    });
  }

  /* ---------------- mega menu ---------------- */
  function initMega(sec) {
    $$('[data-am-mega]', sec).forEach(function (wrap) {
      var trigger = $('.am-mega-trigger', wrap);
      var panel = $('[data-am-mega-panel]', wrap);
      if (!trigger || !panel) return;

      /* keep the panel on screen: it is centered under the trigger, but if
         that pushes it past either edge, nudge it back and move the arrow. */
      function reposition() {
        panel.style.left = '50%';
        panel.style.marginLeft = '0px';
        var inner = panel.querySelector('.am-mega-in');
        if (inner) inner.style.setProperty('--am-arrow-shift', '0px');
        /* measure after layout */
        requestAnimationFrame(function () {
          var r = panel.getBoundingClientRect();
          var pad = 12;
          var shift = 0;
          if (r.right > window.innerWidth - pad) shift = (window.innerWidth - pad) - r.right;
          else if (r.left < pad) shift = pad - r.left;
          if (shift !== 0) {
            panel.style.marginLeft = shift + 'px';
            /* counter-shift the arrow so it still points at the trigger */
            if (inner) inner.style.setProperty('--am-arrow-shift', (-shift) + 'px');
          }
        });
      }
      on(trigger, 'mouseenter', reposition);
      on(trigger, 'focus', reposition);
      on(wrap, 'mouseenter', reposition);

      /* hover-intent: keep panel open with a close delay so the cursor can
         travel from trigger to panel across any sub-pixel gap */
      var closeTimer = null;
      function openMega() { clearTimeout(closeTimer); wrap.classList.add('is-open'); reposition(); }
      function closeMega() { closeTimer = setTimeout(function () { wrap.classList.remove('is-open'); }, 160); }
      on(wrap, 'mouseenter', openMega);
      on(wrap, 'mouseleave', closeMega);
      on(panel, 'mouseenter', function () { clearTimeout(closeTimer); });
      on(trigger, 'focus', openMega);
      on(wrap, 'focusout', function (e) { if (!wrap.contains(e.relatedTarget)) wrap.classList.remove('is-open'); });

      /* hovering a collection link swaps the column-4 model image */
      var feat = panel.querySelector('[data-am-mega-default]');
      var featImgWrap = feat ? feat.querySelector('.am-mega-feat-img') : null;
      var featImg = featImgWrap ? featImgWrap.querySelector('img') : null;
      if (featImg) {
        var defaultSrc = featImg.getAttribute('src');
        panel.querySelectorAll('[data-am-mega-img]').forEach(function (a) {
          var src = a.getAttribute('data-am-mega-img');
          if (!src) return;
          on(a, 'mouseenter', function () {
            if (featImg.getAttribute('src') === src) return;
            featImgWrap.classList.add('is-swapping');
            setTimeout(function () { featImg.setAttribute('src', src); featImgWrap.classList.remove('is-swapping'); }, 180);
          });
        });
        on(panel, 'mouseleave', function () {
          featImgWrap.classList.add('is-swapping');
          setTimeout(function () { featImg.setAttribute('src', defaultSrc); featImgWrap.classList.remove('is-swapping'); }, 180);
        });
      }
      window.addEventListener('resize', function () {
        if (wrap.classList.contains('is-open') || wrap.matches(':hover')) reposition();
      });

      /* keyboard + touch: toggle on click, still navigable via the link */
      on(trigger, 'click', function (e) {
        if (window.matchMedia('(hover:hover)').matches) return; /* desktop uses hover */
        if (!wrap.classList.contains('is-open')) {
          e.preventDefault();
          wrap.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
      on(trigger, 'focus', function () {
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
      wrap.addEventListener('focusout', function (e) {
        if (!wrap.contains(e.relatedTarget)) {
          wrap.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          wrap.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------------- hero slideshow ---------------- */
  function initHero(sec) {
    var slides = $$('.am-slide', sec);
    var dots = $$('.am-dots button', sec);
    if (slides.length < 2) return;
    var idx = 0, speed = parseInt(sec.getAttribute('data-am-speed'), 10) || 5000;
    var timer = null;
    function go(n) {
      slides[idx].classList.remove('is-active');
      if (dots[idx]) dots[idx].classList.remove('is-on');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active');
      if (dots[idx]) dots[idx].classList.add('is-on');
    }
    function play() { stop(); if (speed > 0) timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d, i) { on(d, 'click', function () { go(i); play(); }); });
    on(sec, 'mouseenter', stop);
    on(sec, 'mouseleave', play);
    play();
  }

  /* ---------------- tabs ---------------- */
  function initTabs(sec) {
    var tabs = $$('.am-tab', sec);
    var panels = $$('.am-tab-panel', sec);
    tabs.forEach(function (t, i) {
      on(t, 'click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  }

  /* ---------------- lookbook video ---------------- */
  function initLookbook(sec) {
    var main = $('[data-am-video-url]', sec);
    if (!main) return;
    on(main, 'click', function (e) {
      var url = main.getAttribute('data-am-video-url');
      if (!url) return;
      e.preventDefault();
      var holder = $('.am-look-media', main);
      var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
      var vm = url.match(/vimeo\.com\/(\d+)/);
      var html = '';
      if (yt) { html = '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1" allow="autoplay; fullscreen" allowfullscreen></iframe>'; }
      else if (vm) { html = '<iframe src="https://player.vimeo.com/video/' + vm[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>'; }
      else { html = '<video src="' + url + '" autoplay controls playsinline></video>'; }
      if (holder) {
        holder.innerHTML = html;
        var play = $('.am-play', main);
        if (play) play.style.display = 'none';
        main.style.cursor = 'default';
      }
    }, { once: true });
  }

  /* ---------------- testimonials carousel ---------------- */
  function initReviewCarousel(sec) {
    $$('[data-am-revcar]', sec).forEach(function (car) {
      var track = $('[data-am-revcar-track]', car);
      if (!track) return;
      function step() {
        var card = $('.am-rev', track);
        return card ? card.offsetWidth + 22 : track.clientWidth * 0.8;
      }
      on($('[data-am-revcar-prev]', car), 'click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      on($('[data-am-revcar-next]', car), 'click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  }

  /* ---------------- lookbook mobile carousel ---------------- */
  function initLookCarousel(sec) {
    var track = $('[data-am-lookcar]', sec);
    var dots = $$('[data-am-look-dot]', sec);
    if (!track || !dots.length) return;
    function slides() {
      return $$('.am-look-main, .am-look-tile', track);
    }
    track.addEventListener('scroll', function () {
      if (window.innerWidth > 768) return;
      var items = slides();
      if (!items.length) return;
      var i = Math.round(track.scrollLeft / (items[0].offsetWidth + 12));
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === Math.min(i, dots.length - 1)); });
    }, { passive: true });
    dots.forEach(function (d, n) {
      on(d, 'click', function () {
        var items = slides();
        if (items[n]) track.scrollTo({ left: n * (items[0].offsetWidth + 12), behavior: 'smooth' });
      });
    });
  }

  /* ---------------- newsletter feedback ---------------- */
  function initNewsletter(sec) {
    var q = window.location.search;
    if (q.indexOf('customer_posted=true') > -1) {
      var ok = $('[data-am-news-success]', sec);
      if (ok) ok.style.display = 'block';
    }
  }

  /* ---------------- related products (recommendations fetch) ---------------- */
  function initRelated(sec) {
    var holder = $('[data-am-reco-url]', sec);
    if (!holder) return;
    var url = holder.getAttribute('data-am-reco-url');
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.querySelector('[data-am-reco-grid]');
      if (fresh && fresh.children.length) {
        holder.innerHTML = fresh.innerHTML;
        wishInit();
      } else {
        var wrap = holder.closest('.am-section');
        if (wrap) wrap.style.display = 'none';
      }
    }).catch(function () {});
  }

  /* ================= PRODUCT PAGE ================= */
  function initProduct(sec) {
    if (sec.getAttribute('data-am-init')) return;
    sec.setAttribute('data-am-init', '1');
    var dataEl = $('[data-am-product-json]', sec);
    if (!dataEl) return;
    /* A malformed blob used to return silently here, which disabled EVERY
       control on the PDP with nothing in the console to say why. Now the
       failure is reported and we carry on with empty data, so the static
       bindings (accordions, share, pincode, add to cart) still work. */
    var P;
    try { P = JSON.parse(dataEl.textContent); }
    catch (e) {
      if (window.console && console.error) { console.error('[AM] product JSON is invalid - variant switching disabled', e); }
      P = {};
    }
    if (!P || typeof P !== 'object') { P = {}; }
    var variants = P.variants || [];
    var mediaByAlt = P.mediaByAlt || [];
    var current = null;
    var sel = P.selected || [];

    var stageImg = $('[data-am-stage-img]', sec);
    var priceEl = $('[data-am-price]', sec);
    var wasEl = $('[data-am-was]', sec);
    var offEl = $('[data-am-off]', sec);
    var saveBadge = $('[data-am-save-badge]', sec);
    var atcBtn = $('[data-am-atc]', sec);
    var atcTxt = $('[data-am-atc-text]', sec);
    var buyBtn = $('[data-am-buynow]', sec);
    var stockline = $('[data-am-stockline]', sec);
    var stockTxt = $('[data-am-stock-text]', sec);
    var idInput = $('[data-am-variant-id]', sec);
    var qtyInput = $('[data-am-qty]', sec);
    var sbPrice = $('[data-am-sb-price]', sec);
    var sbWas = $('[data-am-sb-was]', sec);
    var sbImg = $('[data-am-sb-img]', sec);

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function valueAvailable(pos, value) {
      /* every option is orderable - out of stock becomes made to order */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[pos] === value) return true;
      }
      return false;
    }
    function paintOptions() {
      $$('[data-am-opt-value]', sec).forEach(function (b) {
        var pos = parseInt(b.getAttribute('data-am-opt-pos'), 10);
        var val = b.getAttribute('data-am-opt-value');
        b.classList.toggle('is-active', sel[pos] === val);
        var avail = valueAvailable(pos, val);
        b.classList.toggle('is-soldout', !avail);
        var lbl = $('[data-am-opt-label="' + pos + '"]', sec);
        if (lbl) lbl.textContent = sel[pos] || '';
      });
      $$('[data-am-sb-size]', sec).forEach(function (b) {
        b.classList.toggle('is-active', sel.indexOf(b.getAttribute('data-am-sb-size')) > -1);
      });
      /* One note is rendered inside EVERY option group. Previously this grabbed
         the first one in the section and showed it whenever any selection said
         Custom - so choosing Custom under Size opened the note under Bottom.
         Show only the note belonging to the group whose own value is Custom. */
      $$('[data-am-customnote]', sec).forEach(function (note) {
        var group = note.closest('.am-opt') || note.parentElement;
        var pill = group ? $('[data-am-opt-value]', group) : null;
        var pos = pill ? parseInt(pill.getAttribute('data-am-opt-pos'), 10) : -1;
        var val = pos > -1 ? (sel[pos] || '') : '';
        note.classList.toggle('is-show', val.toLowerCase().indexOf('custom') > -1);
      });
    }
    function paintVariant() {
      current = findVariant(sel);
      var v = current;
      if (idInput && v) idInput.value = v.id;
      var allChosen = sel.length && sel.every(function (x) { return !!x; });

      if (v) {
        if (priceEl) priceEl.innerHTML = v.price_f;
        if (sbPrice) sbPrice.innerHTML = v.price_f;
        var hasCompare = v.compare > v.price;
        if (wasEl) { wasEl.innerHTML = hasCompare ? v.compare_f : ''; wasEl.style.display = hasCompare ? '' : 'none'; }
        if (sbWas) { sbWas.innerHTML = hasCompare ? v.compare_f : ''; sbWas.style.display = hasCompare ? '' : 'none'; }
        var pct = hasCompare ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
        if (offEl) { offEl.textContent = 'Save ' + pct + '%'; offEl.style.display = pct > 0 ? '' : 'none'; }
        if (saveBadge) { saveBadge.textContent = pct + '% Off'; saveBadge.style.display = pct > 0 ? '' : 'none'; }
        var vimg = v.image;
        if (!vimg) {
          /* imageForColor returns the media object now, not a bare url */
          for (var ci = 0; ci < sel.length; ci++) { var ai = imageForColor(sel[ci]); if (ai) { vimg = ai.src; break; } }
        }
        /* a variant with its own image: move the gallery to it if that image is
           in the strip, otherwise just update the sticky-bar thumbnail. This
           used to call swapStage, which no longer exists - it would have thrown
           and stopped the rest of the variant paint. */
        if (vimg) {
          var vhit = null;
          for (var mi = 0; mi < mediaByAlt.length; mi++) {
            if (mediaByAlt[mi].src === vimg) { vhit = mediaByAlt[mi]; break; }
          }
          if (vhit && typeof vhit.idx === 'number') goToMedia(vhit.idx);
          if (sbImg) sbImg.src = vimg;
        }

        /* Zero stock only means made to order when the variant is set to keep
           selling. Where it is set to stop at zero the piece really is
           finished, and the buttons have to say so rather than taking an order
           that cannot be fulfilled. Untracked variants are always orderable. */
        var buyable;
        if (v.tracked === false) {
          buyable = v.available !== false;
        } else if (typeof v.qty === 'number' && v.qty > 0) {
          buyable = true;
        } else {
          buyable = (v.policy === 'continue');
        }

        if (atcBtn) atcBtn.disabled = !buyable;
        if (buyBtn) {
          buyBtn.disabled = !buyable;
          buyBtn.hidden = !buyable;
        }
        if (atcTxt) {
          atcTxt.textContent = buyable
            ? (atcTxt.getAttribute('data-add') || 'Add to Bag')
            : (atcTxt.getAttribute('data-sold') || 'Out of stock');
        }

        /* stock line: only once a variant is fully chosen */
        if (stockline && stockTxt) {
          if (allChosen) {
            var isMto = v.mto === true || (typeof v.qty === 'number' && v.qty <= 0);
            stockline.hidden = false;
            stockline.classList.toggle('is-mto', isMto);
            stockTxt.textContent = isMto
              ? (stockTxt.getAttribute('data-mto') || 'Made to order')
              : (stockTxt.getAttribute('data-rts') || 'In stock - ready to ship');
          } else {
            stockline.hidden = true;
          }
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      } else {
        if (stockline) stockline.hidden = true;
        if (atcBtn) atcBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        if (atcTxt) atcTxt.textContent = atcTxt.getAttribute('data-unavail') || 'Select options';
      }
    }
    function imageForColor(colorVal) {
      if (!colorVal || !mediaByAlt.length) return null;
      var needle = colorVal.toLowerCase().trim();
      /* exact alt match first, then contains */
      var hit = mediaByAlt.filter(function (m) { return m.alt === needle; })[0];
      if (!hit) hit = mediaByAlt.filter(function (m) { return m.alt && (m.alt.indexOf(needle) > -1 || needle.indexOf(m.alt) > -1); })[0];
      return hit || null;
    }
    /* The gallery shows every image at once - a two-up grid on desktop, a
       snapping carousel on phone. Overwriting the first image's src (what this
       used to do) left the same photograph appearing twice and never moved the
       view, so choosing a colour looked like it did nothing. Move to the
       matching image instead. */
    function goToMedia(idx) {
      var gal = $('[data-am-gallery]', sec);
      if (!gal) return false;
      var cells = $$('[data-am-gcell]', gal);
      var cell = cells[idx];
      if (!cell) return false;
      var horizontal = gal.scrollWidth > gal.clientWidth + 4;
      if (horizontal) {
        /* phone carousel: scroll the strip itself, leave the page alone */
        gal.scrollTo({ left: cell.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
      } else {
        /* desktop grid: bring the cell into view without yanking the page */
        var r = cell.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          cell.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      return true;
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-opt-value]');
      if (!b || !sec.contains(b)) return;
      var pos = parseInt(b.getAttribute('data-am-opt-pos'), 10);
      var val = b.getAttribute('data-am-opt-value');
      sel[pos] = val;
      /* if this looks like a colour option, move the gallery to the image
         whose ALT text carries that colour name */
      var hit = imageForColor(val);
      if (hit && typeof hit.idx === 'number') goToMedia(hit.idx);
      paintOptions(); paintVariant();
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-am-sb-size]');
      if (!b || !sec.contains(b)) return;
      var val = b.getAttribute('data-am-sb-size');
      var pos = parseInt(b.getAttribute('data-am-sb-pos'), 10);
      sel[pos] = val;
      paintOptions(); paintVariant();
    });

    /* size guide modal */
    var sgModal = $('[data-am-sizeguide-modal]', sec);
    var sgOv = $('[data-am-sg-ov]', sec);
    function openSG() {
      if (!sgModal) return;
      sgModal.classList.add('is-open');
      if (sgOv) sgOv.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeSG() {
      if (!sgModal) return;
      sgModal.classList.remove('is-open');
      if (sgOv) sgOv.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    $$('[data-am-open-sizeguide]', sec).forEach(function (b) { on(b, 'click', openSG); });
    on($('[data-am-close-sizeguide]', sec), 'click', closeSG);
    on(sgOv, 'click', closeSG);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSG(); });

    /* mobile gallery nav arrows (glass) */
    var gal = $('[data-am-gallery]', sec);
    if (gal) {
      var gprev = $('[data-am-gnav-prev]', sec);
      var gnext = $('[data-am-gnav-next]', sec);
      on(gprev, 'click', function () { gal.scrollBy({ left: -gal.clientWidth, behavior: 'smooth' }); });
      on(gnext, 'click', function () { gal.scrollBy({ left: gal.clientWidth, behavior: 'smooth' }); });
    }

    /* atc / buy now */
      /* the note travels with this line, so it survives a cart with several
         different garments in it */
      function amLine(qty) {
        var line = { id: current.id, quantity: qty };
        var props = amProperties(sec);
        if (props === null) return null;   /* a required field is empty */
        /* the free-text note is captured in the cart drawer per line now, not
           here - only the configured customisation fields travel from here */
        if (Object.keys(props).length) { line.properties = props; }
        return line;
      }

    var after = sec.getAttribute('data-am-after') || 'toast';
    on(atcBtn, 'click', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      var lineA = amLine(parseInt(qtyInput.value || 1, 10));
      if (!lineA) return;
      ajaxAdd([lineA], atcBtn, after);
    });
    on($('[data-am-sb-atc]', sec), 'click', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      var lineB = amLine(parseInt(qtyInput.value || 1, 10));
      if (!lineB) return;
      ajaxAdd([lineB], e.currentTarget, after);
    });
    on(buyBtn, 'click', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      var lineC = amLine(parseInt(qtyInput.value || 1, 10));
      if (!lineC) return;
      ajaxAdd([lineC], buyBtn, 'none').then(function (res) {
        /* ajaxAdd swallows its own errors and resolves undefined, so without
           this a failed add still sent the shopper to checkout with nothing
           in the bag. The toast has already explained what went wrong. */
        if (!res) return;

        /* GoKwik attaches to a[href*="/checkout"] and cannot intercept a JS
           redirect, so a straight location change here would skip its checkout
           entirely and drop the customer on Shopify's. The item is already in
           the cart, so clicking a real checkout link hands over to GoKwik's
           cart flow. Only a link GoKwik has actually claimed will do: it marks
           those with data-gokwik-processed, and for an international shopper it
           skips injection and marks nothing, so we fall through to Shopify's
           native checkout, which is what they should get. */
        amCheckoutHandoff();
      });
    });

    /* pincode */
    var pinBtn = $('[data-am-pin-btn]', sec);
    on(pinBtn, 'click', function () {
      var input = $('[data-am-pin-input]', sec);
      var res = $('[data-am-pin-res]', sec);
      if (!input || !res) return;
      var v = (input.value || '').trim();
      var re = new RegExp(sec.getAttribute('data-am-pin-pattern') || '^[1-9][0-9]{5}$');
      if (re.test(v)) {
        res.classList.remove('is-err');
        res.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12.5 10 17.5 19 7"/></svg> ' + (res.getAttribute('data-ok') || 'Delivery available');
      } else {
        res.classList.add('is-err');
        res.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="5.5" y1="5.5" x2="18.5" y2="18.5"/><line x1="18.5" y1="5.5" x2="5.5" y2="18.5"/></svg> ' + (res.getAttribute('data-bad') || 'Please enter a valid pincode');
      }
      res.classList.add('is-show');
    });

    /* accordion */
    $$('.am-acc-head', sec).forEach(function (h) {
      on(h, 'click', function () {
        var item = h.parentElement, body = h.nextElementSibling;
        var open = item.classList.contains('is-open');
        $$('.am-acc-item', sec).forEach(function (i) {
          i.classList.remove('is-open');
          var b = $('.am-acc-body', i); if (b) b.style.maxHeight = null;
        });
        if (!open) { item.classList.add('is-open'); body.style.maxHeight = body.scrollHeight + 'px'; }
      });
    });
    var firstOpen = $('.am-acc-item.is-open .am-acc-body', sec);
    if (firstOpen) firstOpen.style.maxHeight = firstOpen.scrollHeight + 'px';

    /* viewing counter */
    var viewing = $('[data-am-viewing]', sec);
    if (viewing) {
      var min = parseInt(viewing.getAttribute('data-min'), 10) || 8;
      var max = parseInt(viewing.getAttribute('data-max'), 10) || 24;
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      viewing.textContent = viewing.textContent.replace('[n]', n);
    }

    /* sticky bar */
    var bar = $('[data-am-stickybar]', sec);
    if (bar && atcBtn) {
      window.addEventListener('scroll', function () {
        var r = atcBtn.getBoundingClientRect();
        bar.classList.toggle('is-show', r.bottom < 0);
      }, { passive: true });
    }

    paintOptions();
    paintVariant();
  }


  /* ---------------- USP carousel (single row, rotating) ---------------- */
  function initUspCarousel(sec) {
    var car = $('[data-am-usp-car]', sec);
    if (!car) return;
    var slides = $$('.am-usp-slide', car);
    var dots = $$('[data-am-usp-dot]', car);
    if (slides.length < 2) return;

    var i = 0;
    var speed = parseInt(car.getAttribute('data-am-usp-speed'), 10) || 4000;
    var timer = null;

    function go(n) {
      slides[i].classList.remove('is-on');
      if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on');
      if (dots[i]) dots[i].classList.add('is-on');
      /* redraw the icon line art as each one comes in */
      var path = slides[i].querySelector('.am-draw');
      if (path && path.__amLen && window.gsap) {
        window.gsap.fromTo(path, { strokeDashoffset: path.__amLen },
          { strokeDashoffset: 0, duration: 0.9, ease: 'power2.out' });
      }
    }
    function play() { stop(); timer = setInterval(function () { go(i + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (d, n) {
      on(d, 'click', function () { go(n); play(); });
    });
    on(car, 'mouseenter', stop);
    on(car, 'mouseleave', play);

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  }

  /* ---------------- USP line-draw (GSAP) ---------------- */
  function initUspDraw(sec) {
    if (sec.getAttribute('data-am-usp-init')) return;
    sec.setAttribute('data-am-usp-init', '1');
    var paths = $$('.am-usp-svg .am-draw', sec);
    if (!paths.length) return;

    // prep each path: measure length, set dash
    paths.forEach(function (p) {
      var len = 0;
      try { len = p.getTotalLength(); } catch (e) { len = 300; }
      p.style.strokeDasharray = len;
      p.style.strokeDashoffset = len;
      p.__amLen = len;
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      paths.forEach(function (p) { p.style.strokeDashoffset = 0; });
      return;
    }

    function draw(p, i) {
      if (window.gsap) {
        window.gsap.to(p, { strokeDashoffset: 0, duration: 1.1, ease: 'power2.out', delay: (i || 0) * 0.12 });
      } else {
        p.style.transition = 'stroke-dashoffset 1.1s ease ' + ((i || 0) * 0.12) + 's';
        p.style.strokeDashoffset = 0;
      }
    }

    // draw on scroll into view
    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      window.ScrollTrigger.create({
        trigger: sec,
        start: 'top 82%',
        once: true,
        onEnter: function () { paths.forEach(draw); }
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { paths.forEach(draw); obs.disconnect(); }
        });
      }, { threshold: 0.3 });
      io.observe(sec);
    } else {
      paths.forEach(draw);
    }

    // redraw on hover of each item
    $$('.am-usp-item', sec).forEach(function (item) {
      var p = $('.am-usp-svg .am-draw', item);
      if (!p) return;
      item.addEventListener('mouseenter', function () {
        if (window.gsap) {
          window.gsap.fromTo(p, { strokeDashoffset: p.__amLen }, { strokeDashoffset: 0, duration: 0.9, ease: 'power2.out' });
        } else {
          p.style.transition = 'none'; p.style.strokeDashoffset = p.__amLen;
          void p.getBoundingClientRect();
          p.style.transition = 'stroke-dashoffset 0.9s ease'; p.style.strokeDashoffset = 0;
        }
      });
    });
  }


  /* ---------------- collection: sheets, filters, circular nav ---------------- */

  /* ============================================================
     COLLECTION STOCK FILTER
     Ready to Ship / Made to Order. Stock level is not something Shopify's
     own filters can use, so the cards say which they are (data-am-stock)
     and this gathers every page of the current collection through the
     Section Rendering API, keeps the matching cards and paginates them
     here. The current sort and any Shopify filters stay in the request,
     so the two combine. The choice lives in the URL (?stock=), so reload,
     back and forward, and sharing a link all land on the same view.
     ============================================================ */
  function initStockFilter(sec) {
    var results = $('[data-am-coll-results]', sec);
    var countEl = $('[data-am-coll-count]', sec);
    if (!results || sec.__amStockf) return;
    sec.__amStockf = true;

    var sectionId = sec.getAttribute('data-am-section-id');
    var perPage = parseInt(results.getAttribute('data-am-per-page'), 10) || 24;
    var radios = $$('[data-am-stockf] input[name="stock"]', sec);
    var chipSlot = $('[data-am-stockf-chip]', sec);
    var LABEL = { rts: 'Ready to Ship', mto: 'Made to Order' };
    var grid0 = $('.am-prod-grid', results);
    var gridStyle = grid0 ? (grid0.getAttribute('style') || '') : '';
    var VALID = { rts: 1, mto: 1 };
    var nativeHTML = results.innerHTML;
    var nativeCount = countEl ? countEl.textContent : '';
    var loadedWithStock = !!readStock();
    var cache = {};
    var token = 0;

    function qs() { return new URLSearchParams(window.location.search); }
    function readStock() {
      var v = new URLSearchParams(window.location.search).get('stock') || '';
      return VALID[v] ? v : '';
    }
    function readPage() {
      var n = parseInt(qs().get('page'), 10);
      return n > 0 ? n : 1;
    }
    /* the collection as the shopper has it, minus our own two params */
    function baseKey() {
      var p = qs(); p.delete('stock'); p.delete('page');
      var q = p.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }
    function sectionPageUrl(n) {
      var p = qs(); p.delete('stock'); p.set('page', n); p.set('section_id', sectionId);
      return window.location.pathname + '?' + p.toString();
    }
    function urlFor(v, page) {
      var p = qs(); p.delete('stock'); p.delete('page');
      if (v) {
        p.set('stock', v);
        if (page > 1) p.set('page', page);
      }
      var q = p.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }
    function paint(v) {
      radios.forEach(function (r) {
        r.checked = (r.value === v);
        var lab = r.closest('.am-fpill');
        if (lab) lab.classList.toggle('is-on', r.checked);
      });
      if (chipSlot) {
        chipSlot.innerHTML = v
          ? '<button type="button" class="am-apill" data-am-stockf-clear aria-label="Remove ' + LABEL[v] + ' filter">' +
            LABEL[v] + ' <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
          : '';
      }
    }
    function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
    function getText(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }

    /* every card in the collection, once per sort/filter combination */
    function loadAll() {
      var key = baseKey();
      if (cache[key]) return cache[key];
      cache[key] = getText(sectionPageUrl(1)).then(function (html) {
        var first = parse(html);
        var total = 1;
        $$('.am-pagi-a', first).forEach(function (a) {
          var n = parseInt((a.textContent || '').trim(), 10);
          if (n > total) total = n;
        });
        var rest = [];
        for (var i = 2; i <= total; i++) rest.push(i);
        /* a few at a time: fast enough, and polite to the storefront */
        var out = new Array(rest.length), idx = 0;
        function worker() {
          if (idx >= rest.length) return Promise.resolve();
          var mine = idx++;
          return getText(sectionPageUrl(rest[mine])).then(function (h) {
            out[mine] = parse(h);
            return worker();
          });
        }
        var workers = [];
        for (var w = 0; w < Math.min(4, rest.length); w++) workers.push(worker());
        return Promise.all(workers).then(function () {
          var seen = {}, cards = [];
          [first].concat(out).forEach(function (doc) {
            if (!doc) return;
            $$('.am-prod-grid [data-am-card]', doc).forEach(function (c) {
              var link = c.querySelector('a[href*="/products/"]');
              var id = link ? link.getAttribute('href').split('?')[0] : c.outerHTML.length + ':' + cards.length;
              if (seen[id]) return;
              seen[id] = 1;
              var st = cardStockState(c);
              cards.push({ state: st, html: c.outerHTML });
            });
          });
          return cards;
        });
      }).catch(function (e) { delete cache[key]; throw e; });
      return cache[key];
    }

    var CHEV_L = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
    var CHEV_R = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
    function pager(page, pages) {
      if (pages <= 1) return '';
      var h = '<div class="am-pagi">';
      if (page > 1) h += '<button type="button" class="am-pagi-a" data-am-stockf-page="' + (page - 1) + '" aria-label="Previous page">' + CHEV_L + '</button>';
      for (var i = 1; i <= pages; i++) {
        h += (i === page)
          ? '<span class="am-pagi-a is-on" aria-current="page">' + i + '</span>'
          : '<button type="button" class="am-pagi-a" data-am-stockf-page="' + i + '">' + i + '</button>';
      }
      if (page < pages) h += '<button type="button" class="am-pagi-a" data-am-stockf-page="' + (page + 1) + '" aria-label="Next page">' + CHEV_R + '</button>';
      return h + '</div>';
    }
    function reinit() {
      if (typeof initProductCards === 'function') initProductCards(results);
      if (typeof wishInit === 'function') wishInit();
    }
    function setCount(n) {
      if (countEl) countEl.textContent = n + (n === 1 ? ' piece' : ' pieces');
    }
    function scrollToBar() {
      var target = $('.am-coll-bar', sec) || results;
      var top = target.getBoundingClientRect().top + window.pageYOffset;
      var offset = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--am-header-h')) || 0) + 110;
      window.scrollTo({ top: Math.max(0, top - offset), behavior: 'smooth' });
    }

    function renderFiltered(v, page, scroll) {
      var mine = ++token;
      results.classList.add('is-loading');
      results.setAttribute('aria-busy', 'true');
      return loadAll().then(function (cards) {
        if (mine !== token) return;
        var list = cards.filter(function (c) { return c.state === v; });
        var pages = Math.max(1, Math.ceil(list.length / perPage));
        page = Math.min(Math.max(1, page || 1), pages);
        if (!list.length) {
          results.innerHTML =
            '<div class="am-empty"><h3 class="am-serif">Nothing ' +
            (v === 'rts' ? 'ready to ship' : 'made to order') +
            ' here yet</h3><p>Try the other option, or show everything.</p>' +
            '<button type="button" class="am-btn am-btn--outline" data-am-stockf-clear>Show everything</button></div>';
        } else {
          var slice = list.slice((page - 1) * perPage, page * perPage);
          results.innerHTML = '<div class="am-prod-grid" style="' + gridStyle + '">' +
            slice.map(function (c) { return c.html; }).join('') + '</div>' + pager(page, pages);
        }
        setCount(list.length);
        results.classList.remove('is-loading');
        results.removeAttribute('aria-busy');
        reinit();
        if (scroll) scrollToBar();
      }).catch(function () {
        if (mine !== token) return;
        /* if the pages cannot be gathered, a full load still lands right */
        window.location.href = urlFor(v, page);
      });
    }

    function renderNative(scroll) {
      var mine = ++token;
      /* arrived on the unfiltered page and never left it: put it straight back */
      if (!loadedWithStock) {
        results.innerHTML = nativeHTML;
        if (countEl) countEl.textContent = nativeCount;
        results.classList.remove('is-loading');
        reinit();
        if (scroll) scrollToBar();
        return Promise.resolve();
      }
      results.classList.add('is-loading');
      return getText(sectionPageUrl(1)).then(function (html) {
        if (mine !== token) return;
        var doc = parse(html);
        var r = $('[data-am-coll-results]', doc);
        var c = $('[data-am-coll-count]', doc);
        if (r) results.innerHTML = r.innerHTML;
        if (c && countEl) countEl.textContent = c.textContent;
        results.classList.remove('is-loading');
        reinit();
        if (scroll) scrollToBar();
      }).catch(function () { window.location.href = urlFor('', 1); });
    }

    function apply(v, page, scroll) {
      paint(v);
      return v ? renderFiltered(v, page, scroll) : renderNative(scroll);
    }

    /* In the sheet the choice waits for Show results, like every other filter
       there. A radio cannot normally be unset, so a second tap on the chosen
       one clears it. */
    /* The radio itself is hidden, so the press lands on its label. Note
       whether it was already chosen on the label's pointerdown - before the
       browser's own click checks it - and if so, clear it on the click. */
    radios.forEach(function (r) {
      var lab = r.closest('.am-fpill');
      var pressTarget = lab || r;
      on(pressTarget, 'pointerdown', function () { r.__amWas = r.checked; });
      on(pressTarget, 'keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') r.__amWas = r.checked;
      });
      on(r, 'click', function () {
        if (r.__amWas) r.checked = false;
        r.__amWas = false;
        radios.forEach(function (x) {
          var l = x.closest('.am-fpill');
          if (l) l.classList.toggle('is-on', x.checked);
        });
      });
    });

    /* the chip beside the count removes the filter straight away */
    if (chipSlot) {
      on(chipSlot, 'click', function (e) {
        if (!(e.target.closest && e.target.closest('[data-am-stockf-clear]'))) return;
        e.preventDefault();
        history.pushState({ amStock: '' }, '', urlFor('', 1));
        apply('', 1, false);
      });
    }

    /* Show results in the sheet hands over here when only availability moved */
    sec.__amStockApply = function (v) {
      history.pushState({ amStock: v }, '', urlFor(v, 1));
      apply(v, 1, true);
    };

    on(results, 'click', function (e) {
      var pg = e.target.closest ? e.target.closest('[data-am-stockf-page]') : null;
      if (pg) {
        e.preventDefault();
        var v = readStock();
        var n = parseInt(pg.getAttribute('data-am-stockf-page'), 10) || 1;
        history.pushState({ amStock: v, page: n }, '', urlFor(v, n));
        renderFiltered(v, n, true);
        return;
      }
      if (e.target.closest && e.target.closest('[data-am-stockf-clear]')) {
        e.preventDefault();
        history.pushState({ amStock: '' }, '', urlFor('', 1));
        apply('', 1, true);
      }
    });

    window.addEventListener('popstate', function () {
      apply(readStock(), readPage(), false);
    });

    /* Sort options are plain links to ?sort_by=, which threw away the stock
       choice and any active filters. Swap only the sort and keep the rest. */
    on(sec, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('a.am-sortopt') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var sort;
      try { sort = new URL(a.getAttribute('href'), window.location.origin).searchParams.get('sort_by'); }
      catch (err) { sort = null; }
      if (!sort) return;
      e.preventDefault();
      var p = qs();
      p.set('sort_by', sort);
      p.delete('page');
      window.location.href = window.location.pathname + '?' + p.toString();
    });

    /* a shared or reloaded link with ?stock= opens already filtered */
    var initial = readStock();
    paint(initial);
    if (initial) renderFiltered(initial, readPage(), false);
  }

  function initCollection(sec) {
    if (sec.getAttribute('data-am-coll-init')) return;
    sec.setAttribute('data-am-coll-init', '1');
    /* isolated: a fault in the stock filter must never stop sort and filter */
    try { initStockFilter(sec); } catch (err) { if (window.console) console.warn('stock filter', err); }

    var ov = $('[data-am-sheet-ov]', sec);
    function openSheet(name) {
      var sh = $('[data-am-sheet="' + name + '"]', sec);
      if (!sh) return;
      sh.classList.add('is-open');
      if (ov) ov.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeSheets() {
      $$('[data-am-sheet]', sec).forEach(function (sh) { sh.classList.remove('is-open'); });
      if (ov) ov.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    $$('[data-am-open-sheet]', sec).forEach(function (b) {
      on(b, 'click', function () { openSheet(b.getAttribute('data-am-open-sheet')); });
    });
    $$('[data-am-close-sheet]', sec).forEach(function (b) { on(b, 'click', closeSheets); });
    on(ov, 'click', closeSheets);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });

    /* filter form -> build Shopify filter URL */
    var form = $('[data-am-filter-form]', sec);
    function applyFilters() {
      if (!form) return;
      var params = [];
      var stockPick = '';
      $$('input', form).forEach(function (inp) {
        /* availability is ours, not a Shopify filter - read it separately */
        if (inp.name === 'stock') {
          if (inp.type === 'radio' && inp.checked && (inp.value === 'rts' || inp.value === 'mto')) stockPick = inp.value;
          return;
        }
        if (inp.type === 'checkbox' || inp.type === 'radio') {
          if (inp.checked && !inp.disabled) {
            params.push(encodeURIComponent(inp.name) + '=' + encodeURIComponent(inp.value));
          }
        } else if (inp.value !== '') {
          params.push(encodeURIComponent(inp.name) + '=' + encodeURIComponent(inp.value));
        }
      });

      /* If the Shopify filters are exactly as they were and only availability
         moved, filter in place instead of reloading the page. */
      var cur = new URLSearchParams(window.location.search);
      var curNative = [];
      cur.forEach(function (val, key) {
        if (key === 'stock' || key === 'page' || key === 'sort_by' || key === 'section_id') return;
        curNative.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
      });
      var same = curNative.slice().sort().join('&') === params.slice().sort().join('&');
      if (same && typeof sec.__amStockApply === 'function') {
        closeSheets();
        sec.__amStockApply(stockPick);
        return;
      }

      var base = window.location.pathname;
      var sortSel = cur.get('sort_by');
      if (sortSel) params.push('sort_by=' + encodeURIComponent(sortSel));
      if (stockPick) params.push('stock=' + stockPick);
      window.location.href = base + (params.length ? '?' + params.join('&') : '');
    }
    on($('[data-am-apply-filter]', sec), 'click', applyFilters);

    /* instant visual toggle on pills */
    $$('.am-fpill input', sec).forEach(function (inp) {
      on(inp, 'change', function () {
        inp.closest('.am-fpill').classList.toggle('is-on', inp.checked);
      });
    });

    /* circular nav arrows */
    var nav = $('[data-am-circnav]', sec);
    if (nav) {
      on($('[data-am-circ-prev]', sec), 'click', function () { nav.scrollBy({ left: -300, behavior: 'smooth' }); });
      on($('[data-am-circ-next]', sec), 'click', function () { nav.scrollBy({ left: 300, behavior: 'smooth' }); });
    }
  }

  /* ---------------- home collection tiles carousel (issue #1) ---------------- */
  function initTilesCarousel(scope) {
    $$('[data-am-tiles-carousel]', scope || document).forEach(function (strip) {
      if (strip.__amTiles) return; strip.__amTiles = true;
      var tiles = Array.prototype.slice.call(strip.children);
      var dotsWrap = strip.parentElement ? strip.parentElement.querySelector('[data-am-tiles-dots]') : null;

      /* drag-to-scroll */
      var down = false, startX = 0, startScroll = 0, moved = false;
      on(strip, 'pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startScroll = strip.scrollLeft;
        strip.classList.add('is-grabbing');
      });
      on(strip, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 8) moved = true;
        strip.scrollLeft = startScroll - dx;
      });
      function endDrag() { down = false; strip.classList.remove('is-grabbing'); }
      /* On release, navigate ourselves when the pointer did not actually drag.
         The strip is a scroll container with drag handling on top, and relying
         on the native click surviving that layer proved unreliable - a tile
         could swallow the tap and go nowhere. Driving it explicitly is the same
         approach used for the collection circles, which is dependable. */
      on(strip, 'pointerup', function (e) {
        var wasDrag = moved;
        endDrag();
        if (wasDrag) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a) {
          var el = document.elementFromPoint(e.clientX, e.clientY);
          a = el && el.closest ? el.closest('a[href]') : null;
        }
        if (a && strip.contains(a)) {
          var href = a.getAttribute('href');
          if (href && href !== '#') { e.preventDefault(); window.location.href = href; }
        }
      });
      on(strip, 'pointercancel', endDrag);
      on(strip, 'pointerleave', endDrag);
      /* swallow the synthetic click only when it followed a real drag */
      on(strip, 'click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
        moved = false;
      }, true);

      /* dots - one per tile, reflect nearest snapped tile */
      var dots = [];
      if (dotsWrap && tiles.length > 1) {
        tiles.forEach(function (t, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          on(b, 'click', function () { strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft, behavior: 'smooth' }); });
          dotsWrap.appendChild(b); dots.push(b);
        });
        var syncing;
        function syncDots() {
          var mid = strip.scrollLeft + strip.clientWidth / 2;
          var best = 0, bestD = Infinity;
          tiles.forEach(function (t, i) {
            var c = t.offsetLeft - strip.offsetLeft + t.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
        }
        on(strip, 'scroll', function () {
          if (syncing) cancelAnimationFrame(syncing);
          syncing = requestAnimationFrame(syncDots);
        });
        syncDots();
      }

      /* optional autoplay */
      if (strip.getAttribute('data-autoplay') === 'true' && tiles.length > 1) {
        var secs = parseInt(strip.getAttribute('data-speed'), 10) || 4;
        var idx = 0, timer = null;
        function step() {
          idx = (idx + 1) % tiles.length;
          var t = tiles[idx];
          /* if we wrapped to start, jump back to 0 */
          strip.scrollTo({ left: idx === 0 ? 0 : (t.offsetLeft - strip.offsetLeft), behavior: 'smooth' });
        }
        function play() { stop(); timer = setInterval(step, secs * 1000); }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        on(strip, 'pointerenter', stop);
        on(strip, 'pointerleave', play);
        play();
      }
    });
  }

  /* ---------------- footer menu accordion (mobile only, issue #7) ---------------- */
  function initFooterAccordion(scope) {
    $$('[data-am-fcol]', scope || document).forEach(function (col) {
      var btn = $('[data-am-fcol-toggle]', col);
      if (!btn || btn.__amF) return; btn.__amF = true;
      on(btn, 'click', function () {
        /* only acts as accordion on mobile widths; desktop is always open */
        if (window.innerWidth > 768) return;
        var open = col.getAttribute('aria-expanded') === 'true';
        col.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ============================================================
     AM SELF-CONTAINED CART DRAWER
     Renders from /cart.js into our own markup. Does NOT depend on
     Gecko's lazy mini_cart hydration (which hangs on live). This is
     the reliable cart the storefront actually uses.
     ============================================================ */
  var AMCart = (function () {
    var drawer, overlay, itemsWrap, emptyEl, footEl, subtotalEl, loadingEl, tpl;
    var money_format = (window.T4Sconfigs && T4Sconfigs.moneyFormat) || (window.Shopify && Shopify.money_format) || 'Rs. {{amount}}';
    var booted = false, busy = false;

    function formatMoney(cents) {
      /* cents -> localized string using Shopify money_format */
      function fmt(n, precision, thousands, decimal) {
        if (isNaN(n) || n == null) return '0';
        precision = precision == null ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';
        var value = (n / 100).toFixed(precision);
        var parts = value.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents2 = parts[1] ? decimal + parts[1] : '';
        return dollars + cents2;
      }
      var val = '';
      var pat = /\{\{\s*(\w+)\s*\}\}/;
      var m = money_format.match(pat);
      var token = m ? m[1] : 'amount';
      switch (token) {
        case 'amount': val = fmt(cents, 2); break;
        case 'amount_no_decimals': val = fmt(cents, 0); break;
        case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': val = fmt(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': val = fmt(cents, 0, ' '); break;
        default: val = fmt(cents, 2);
      }
      var out = money_format.replace(pat, val);
      /* Gecko's moneyFormat wraps the amount in <span class="money">...</span>
         for its live currency converter. We render into our own nodes, so strip
         any tags and decode the few entities currency symbols use. */
      out = out.replace(/<[^>]*>/g, '');
      out = out.replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ')
               .replace(/&pound;/g, '\u00a3').replace(/&euro;/g, '\u20ac')
               .replace(/&#8377;/g, '\u20b9').replace(/&#165;/g, '\u00a5');
      return out.trim();
    }

    function cache() {
      drawer = document.getElementById('am-cart-drawer');
      if (!drawer) return false;
      overlay = document.querySelector('[data-am-cart-ov]');
      itemsWrap = drawer.querySelector('[data-am-cart-items]');
      emptyEl = drawer.querySelector('[data-am-cart-empty]');
      footEl = drawer.querySelector('[data-am-cart-foot]');
      subtotalEl = drawer.querySelector('[data-am-cart-subtotal]');
      loadingEl = drawer.querySelector('[data-am-cart-loading]');
      tpl = document.querySelector('[data-am-cart-item-tpl]');
      return true;
    }

    function setLoading(on) {
      if (loadingEl) loadingEl.hidden = !on;
    }

    function render(cart) {
      if (!itemsWrap || !tpl) return;
      var count = cart.item_count || 0;
      /* empty vs filled */
      if (emptyEl) emptyEl.hidden = count > 0;
      if (footEl) footEl.hidden = count === 0;
      itemsWrap.innerHTML = '';

      cart.items.forEach(function (item, idx) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        var line = idx + 1;
        node.setAttribute('data-line', line);
        node.setAttribute('data-key', item.key);

        var img = node.querySelector('[data-am-ci-img]');
        if (img) {
          if (item.image) { img.src = item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_200x$1$2'); img.alt = item.product_title || ''; }
          else { img.style.display = 'none'; }
        }
        node.querySelectorAll('[data-am-ci-link]').forEach(function (a) { a.setAttribute('href', item.url); });
        var t = node.querySelector('[data-am-ci-title]'); if (t) t.textContent = item.product_title;

        /* Per-line note. Read back from the line's own property so it survives
           a drawer refresh, and saved with cart/change.js against the line key
           rather than the variant id - two lines can share a variant. */
        var noteWrap = node.querySelector('[data-am-ci-note]');
        var noteBtn = node.querySelector('[data-am-ci-note-toggle]');
        var noteIn = node.querySelector('[data-am-ci-note-input]');
        var noteLbl = node.querySelector('[data-am-ci-note-label]');
        var noteOk = node.querySelector('[data-am-ci-note-saved]');
        if (noteWrap && noteBtn && noteIn) {
          var existing = (item.properties && item.properties['Note']) ? item.properties['Note'] : '';
          noteIn.value = existing;
          if (existing) { noteWrap.hidden = false; noteBtn.setAttribute('aria-expanded', 'true'); }
          if (noteLbl) noteLbl.textContent = existing ? 'Edit note' : 'Add a note';

          on(noteBtn, 'click', function () {
            noteWrap.hidden = !noteWrap.hidden;
            noteBtn.setAttribute('aria-expanded', noteWrap.hidden ? 'false' : 'true');
            if (!noteWrap.hidden) noteIn.focus();
          });

          var noteTimer = null;
          function saveNote() {
            /* carry the line's other properties through - sending only Note
               would wipe any customisation captured on the product page */
            var props = {};
            if (item.properties) {
              Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
            }
            var val = (noteIn.value || '').trim();
            if (val) { props['Note'] = val; } else { delete props['Note']; }
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, properties: props })
            }).then(function (r) { return r.ok ? r.json() : null; })
              .then(function () {
                item.properties = props;
                if (noteLbl) noteLbl.textContent = val ? 'Edit note' : 'Add a note';
                if (noteOk) {
                  noteOk.hidden = false;
                  clearTimeout(noteOk.__t);
                  noteOk.__t = setTimeout(function () { noteOk.hidden = true; }, 1600);
                }
              }).catch(function () {});
          }
          on(noteIn, 'blur', saveNote);
          on(noteIn, 'input', function () { clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 900); });
        }

        var v = node.querySelector('[data-am-ci-variant]');
        if (v) {
          /* show variant options unless it is the Default Title */
          var opts = (item.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' / ');
          if (opts) v.textContent = opts; else v.style.display = 'none';
        }

        var p = node.querySelector('[data-am-ci-price]');
        if (p) {
          if (item.original_line_price !== item.final_line_price) {
            p.innerHTML = '<span class="am-ci-price-sale">' + formatMoney(item.final_price) + '</span> <s>' + formatMoney(item.original_price) + '</s>';
          } else {
            p.textContent = formatMoney(item.final_price);
          }
        }
        var q = node.querySelector('[data-am-ci-qty]'); if (q) q.textContent = item.quantity;

        itemsWrap.appendChild(node);
      });

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      /* keep any header bag counters in sync */
      $$('[data-am-cart-count]').forEach(function (el) { el.textContent = count; });
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function refresh() {
      return fetchCart().then(function (cart) { render(cart); return cart; });
    }

    function changeLine(line, qty) {
      if (busy) return Promise.resolve();
      busy = true; setLoading(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; })
        .catch(function () {})
        .finally(function () { busy = false; setLoading(false); });
    }

    function open() {
      if (!drawer) return;
      setLoading(true);
      refresh().finally(function () { setLoading(false); });
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); }
      document.documentElement.classList.add('am-cart-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); }
      document.documentElement.classList.remove('am-cart-open');
      document.body.style.overflow = '';
    }

    function bind() {
      /* open from any cart link/icon */
      document.addEventListener('click', function (e) {
        var link = e.target.closest('.am-cart-link, [data-am-cart-open], a[href$="/cart"], a[href*="/cart?"]');
        if (!link || e.metaKey || e.ctrlKey) return;
        /* A /cart link that lives inside the drawer itself is a deliberate
           request for the full cart page - View Cart is the obvious case.
           Swallowing it here re-opened an already-open drawer and looked like
           a dead button, so anything inside the drawer navigates normally. */
        if (link.closest('.am-cart')) return;
        e.preventDefault();
        open();
      });
      /* close */
      if (overlay) on(overlay, 'click', close);
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-am-cart-close]')) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
      });
      /* qty +/- and remove (delegated) */
      itemsWrap.addEventListener('click', function (e) {
        var row = e.target.closest('[data-am-ci]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var qtyEl = row.querySelector('[data-am-ci-qty]');
        var cur = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
        if (e.target.closest('[data-am-ci-inc]')) { changeLine(line, cur + 1); }
        else if (e.target.closest('[data-am-ci-dec]')) { changeLine(line, Math.max(0, cur - 1)); }
        else if (e.target.closest('[data-am-ci-remove]')) { changeLine(line, 0); }
      });
    }

    return {
      init: function () {
        if (booted) return; if (!cache()) return; booted = true;
        bind();
        refresh();
        /* let other code (quick-add) open + refresh us */
        document.addEventListener('am:cart:open', open);
        document.addEventListener('am:cart:refresh', function () { refresh(); });
      },
      open: open, close: close, refresh: refresh, render: render,
      /* other features (wishlist page) need the same money formatting */
      money: formatMoney
    };
  })();

  /* ============================================================
     AM WISHLIST DRAWER
     Reads the same localStorage list the header badge counts, resolves
     each handle through /products/{handle}.js, and offers Move to bag
     (add to cart, then drop from the wishlist) alongside Remove.
     ============================================================ */
  var AMWish = (function () {
    var drawer, overlay, itemsWrap, emptyEl, footEl, countEl, loadingEl, tpl;
    var booted = false, busy = false;

    function cache() {
      drawer = document.getElementById('am-wish-drawer');
      if (!drawer) return false;
      overlay = $('[data-am-wish-ov]');
      itemsWrap = $('[data-am-wishd-items]', drawer);
      emptyEl = $('[data-am-wishd-empty]', drawer);
      footEl = $('[data-am-wishd-foot]', drawer);
      countEl = $('[data-am-wishd-count]', drawer);
      loadingEl = $('[data-am-wishd-loading]', drawer);
      tpl = $('[data-am-wishd-item-tpl]');
      return !!(itemsWrap && tpl);
    }
    function setLoading(on) { if (loadingEl) loadingEl.hidden = !on; }
    function money(c) { try { return AMCart.money(c); } catch (e) { return ''; } }

    function firstAvailableVariant(p) {
      if (!p || !p.variants || !p.variants.length) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) return p.variants[i];
      }
      return p.variants[0];
    }

    function row(p) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-handle', p.handle);
      var img = $('[data-am-wi-img]', node);
      if (img) {
        var src = p.featured_image || (p.images && p.images[0]);
        if (src) { img.src = String(src).replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_200x$1$2'); img.alt = p.title || ''; }
        else { img.style.display = 'none'; }
      }
      $$('[data-am-wi-link]', node).forEach(function (a) { a.setAttribute('href', p.url || '/products/' + p.handle); });
      var t = $('[data-am-wi-title]', node); if (t) t.textContent = p.title || '';
      var pr = $('[data-am-wi-price]', node); if (pr) pr.textContent = money(p.price);
      var v = firstAvailableVariant(p);
      var moveBtn = $('[data-am-wi-move]', node);
      var note = $('[data-am-wi-note]', node);
      /* a piece can sell out while it sits in the wishlist - say so rather than
         offering a button that will fail */
      if (moveBtn && (!v || v.available === false)) {
        moveBtn.disabled = true;
        if (note) { note.textContent = 'Currently unavailable'; note.hidden = false; }
      } else if (moveBtn && v) {
        moveBtn.setAttribute('data-variant', v.id);
      }
      return node;
    }

    function render(products, handles) {
      itemsWrap.innerHTML = '';
      var n = 0;
      products.forEach(function (p) { if (p) { itemsWrap.appendChild(row(p)); n++; } });
      if (emptyEl) emptyEl.hidden = n > 0;
      if (footEl) footEl.hidden = n === 0;
      if (countEl) { countEl.textContent = n === 1 ? '1 piece' : n + ' pieces'; countEl.hidden = n === 0; }
    }

    function load() {
      var handles = wishGet();
      if (!handles.length) { render([], []); return Promise.resolve(); }
      setLoading(true);
      return Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (res) {
        /* drop handles that no longer resolve so the list cannot rot */
        var live = [];
        res.forEach(function (p, i) { if (p) live.push(handles[i]); });
        if (live.length !== handles.length) { wishSet(live); wishInit(); }
        render(res, live);
      }).finally(function () { setLoading(false); });
    }

    function removeHandle(h) {
      var list = wishGet();
      var i = list.indexOf(h);
      if (i > -1) { list.splice(i, 1); wishSet(list); }
      wishInit();
    }

    function moveOne(node) {
      var h = node.getAttribute('data-handle');
      var btn = $('[data-am-wi-move]', node);
      var vid = btn && btn.getAttribute('data-variant');
      if (!vid) return Promise.resolve();
      return ajaxAdd([{ id: parseInt(vid, 10), quantity: 1 }], btn, 'none')
        .then(function () { removeHandle(h); });
    }

    function open() {
      if (!drawer) return;
      load();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); }
      document.documentElement.classList.add('am-wish-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); }
      document.documentElement.classList.remove('am-wish-open');
      document.body.style.overflow = '';
    }

    function bind() {
      document.addEventListener('click', function (e) {
        var link = e.target.closest('[data-am-wish-open], .am-wish-link');
        if (link && !e.metaKey && !e.ctrlKey) { e.preventDefault(); open(); return; }
        if (e.target.closest('[data-am-wishd-close]')) { e.preventDefault(); close(); }
      });
      if (overlay) on(overlay, 'click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
      });
      on(itemsWrap, 'click', function (e) {
        var node = e.target.closest('[data-am-wi]');
        if (!node) return;
        if (e.target.closest('[data-am-wi-remove]')) {
          e.preventDefault();
          removeHandle(node.getAttribute('data-handle'));
          load();
        } else if (e.target.closest('[data-am-wi-move]')) {
          e.preventDefault();
          if (busy) return; busy = true;
          moveOne(node).finally(function () { busy = false; load(); });
        }
      });
      var moveAll = $('[data-am-wishd-move-all]', drawer);
      if (moveAll) on(moveAll, 'click', function () {
        if (busy) return; busy = true;
        var nodes = $$('[data-am-wi]', itemsWrap).filter(function (n) {
          var b = $('[data-am-wi-move]', n); return b && !b.disabled;
        });
        setLoading(true);
        (function next(i) {
          if (i >= nodes.length) {
            busy = false; setLoading(false); load();
            try { document.dispatchEvent(new CustomEvent('am:cart:open')); } catch (e) {}
            return;
          }
          moveOne(nodes[i]).finally(function () { next(i + 1); });
        })(0);
      });
      var clear = $('[data-am-wishd-clear]', drawer);
      if (clear) on(clear, 'click', function () {
        wishSet([]); wishInit(); load();
      });
      document.addEventListener('am:wish:open', open);
      window.addEventListener('storage', function (e) {
        if (e.key === WKEY && drawer && drawer.classList.contains('is-open')) load();
      });
    }

    return {
      init: function () { if (booted) return; if (!cache()) return; booted = true; bind(); },
      open: open, close: close, refresh: load
    };
  })();

  /* ============================================================
     SIZE GUIDE TABLE SLIDER
     The charts scroll sideways on a phone, but overlay scrollbars
     only appear mid-drag, so a table wider than the screen reads as
     cut off. This draws a slider that is always visible when there
     is something to scroll, tracks the position, and can be dragged.
     ============================================================ */
  function initSgSliders(root) {
    $$('[data-am-sg-scroll]', root || document).forEach(function (pane) {
      if (pane.__amSg) return;
      var slider = pane.parentElement && $('[data-am-sg-slider]', pane.parentElement);
      var thumb = slider && $('[data-am-sg-thumb]', slider);
      if (!slider || !thumb) return;
      pane.__amSg = true;

      function overflow() { return pane.scrollWidth - pane.clientWidth; }

      function paint() {
        var over = overflow();
        if (over <= 2) { slider.hidden = true; return; }
        slider.hidden = false;
        var ratio = pane.clientWidth / pane.scrollWidth;
        var tw = Math.max(ratio * 100, 12);
        thumb.style.width = tw + '%';
        var progress = pane.scrollLeft / over;
        thumb.style.left = (progress * (100 - tw)) + '%';
      }

      on(pane, 'scroll', paint);
      window.addEventListener('resize', paint);
      /* the size guide opens in a modal, so the panes have no width until it
         is shown - repaint when it becomes visible rather than only on load */
      if (window.ResizeObserver) {
        try { new ResizeObserver(paint).observe(pane); } catch (e) {}
      }

      /* drag the thumb, and jump on a click anywhere along the track */
      var dragging = false;
      function seek(clientX) {
        var r = slider.getBoundingClientRect();
        var tw = thumb.getBoundingClientRect().width;
        var x = clientX - r.left - tw / 2;
        var span = r.width - tw;
        if (span <= 0) return;
        var p = Math.min(Math.max(x / span, 0), 1);
        pane.scrollLeft = p * overflow();
      }
      on(slider, 'pointerdown', function (e) {
        dragging = true;
        try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        seek(e.clientX);
      });
      on(slider, 'pointermove', function (e) { if (dragging) seek(e.clientX); });
      on(slider, 'pointerup', function () { dragging = false; });
      on(slider, 'pointercancel', function () { dragging = false; });

      paint();
    });
  }

  /* ============================================================
     ORDER NOTE (cart drawer)
     Saved to the cart on blur via /cart/update.js. Debounced while
     typing so a long note is not one request per keystroke.
     ============================================================ */
  function initCartNote() {
    var wrap = $('[data-am-cart-note]');
    if (!wrap || wrap.__amNote) return;
    wrap.__amNote = true;
    var toggle = $('[data-am-note-toggle]', wrap);
    var body = $('[data-am-note-body]', wrap);
    var input = $('[data-am-note-input]', wrap);
    var saved = $('[data-am-note-saved]', wrap);
    var label = $('[data-am-note-label]', wrap);
    if (!toggle || !body || !input) return;
    var timer = null;

    function setLabel() {
      if (!label) return;
      label.textContent = (input.value || '').trim() ? 'Edit order note' : 'Add order note';
    }
    /* a note already on the cart should be visible, not hidden behind a link
       the customer has no reason to open */
    if ((input.value || '').trim()) { body.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
    setLabel();

    on(toggle, 'click', function () {
      body.hidden = !body.hidden;
      toggle.setAttribute('aria-expanded', body.hidden ? 'false' : 'true');
      if (!body.hidden) input.focus();
    });

    function save() {
      var note = input.value || '';
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note })
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function () {
          setLabel();
          if (saved) {
            saved.hidden = false;
            clearTimeout(saved.__t);
            saved.__t = setTimeout(function () { saved.hidden = true; }, 1800);
          }
        }).catch(function () {});
    }
    on(input, 'blur', save);
    on(input, 'input', function () {
      clearTimeout(timer);
      timer = setTimeout(save, 900);
    });
  }

  /* ============================================================
     PRODUCT NOTE (product page)
     Sent as a line item property so it stays attached to that line
     rather than to the whole order - a note about one garment is
     useless on the order if three garments are in the bag.
     ============================================================ */
  /* Collect the customisable fields into line item properties. Returns null
     when a required field is empty, so the caller can stop rather than add a
     half-specified garment to the bag. */
  function amProperties(sec) {
    if (!sec) return {};
    var out = {};
    var bad = null;
    $$('[data-am-prop]', sec).forEach(function (wrap) {
      var err = $('[data-am-prop-err]', wrap);
      if (err) err.hidden = true;
      wrap.classList.remove('is-invalid');

      var radios = $$('input[type="radio"][data-am-prop-input]', wrap);
      var val = '', name = '', required = false;

      if (radios.length) {
        name = radios[0].getAttribute('data-am-prop-name');
        required = radios[0].required;
        radios.forEach(function (r) { if (r.checked) val = r.value; });
      } else {
        var el = $('[data-am-prop-input]', wrap);
        if (!el) return;
        name = el.getAttribute('data-am-prop-name');
        required = el.required;
        if (el.hasAttribute('data-am-prop-checkbox')) {
          val = el.checked ? (el.value || 'Yes') : '';
        } else {
          val = (el.value || '').trim();
        }
      }
      if (required && val === '') {
        wrap.classList.add('is-invalid');
        if (err) err.hidden = false;
        if (!bad) bad = wrap;
        return;
      }
      if (val !== '' && name) out[name] = val;
    });
    if (bad) {
      bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return null;
    }
    return out;
  }


  /* ============================================================
     CART DRAWER MARQUEE
     Rendered by Liquid from the AM Cart Drawer settings, so the
     drawer can carry its own message, colours and speed rather
     than mirroring the site announcement bar.
     ============================================================ */
  function initCartMarquee() {
    /* Marquee is rendered by Liquid from its own settings now, so there is
       nothing to build at runtime. Kept as a no-op because the boot list and
       the section:load handler both call it. */
    return;
  }

  /* ============================================================
     STOCK PILL FIT
     The size list is capped by a setting, but a card in a four-up
     collection grid is much narrower than one in a home carousel,
     so the same list that fits at home overflowed there. Trim to
     what actually fits the card and say how many are left.
     ============================================================ */
  function fitStockSizes(tag) {
    if (!tag) return;
    var szEl = $('.am-card-stock-sz', tag);
    if (!szEl) return;
    var all = (tag.__amSizes || []);
    if (!all.length) return;
    /* Do not bail when the span is hidden. It gets hidden when the card is too
       narrow for even one size, and bailing on that meant it never came back
       when the card widened again - the sizes vanished on the first reflow and
       stayed gone. */
    szEl.hidden = false;

    /* Measure the box the pill actually gets, not the card. Since the pill
       moved onto the photograph it is capped well short of the card width to
       stay clear of the quick add button, so measuring the card meant the
       trimmer thought everything fitted and the sizes were simply clipped off
       - which is why the pill read "Ready to Ship" and nothing more. */
    var card = tag.closest('.am-card') || tag.parentElement;
    var room = 0;
    /* Only a pixel max-width is a real measurement. A percentage comes back
       from getComputedStyle as the literal "100%", which parseFloat reads as
       100 - a hundred pixels - and the trimmer would strip almost every size.
       Anything that is not pixels falls back to the card's own width. */
    var mwRaw = window.getComputedStyle(tag).maxWidth || '';
    var mw = /px$/.test(mwRaw) ? parseFloat(mwRaw) : NaN;
    if (isFinite(mw) && mw > 0) {
      room = mw - 2;
    } else {
      room = (card ? card.clientWidth : tag.clientWidth) - 4;
    }
    if (room <= 0) return;

    /* Two lines are allowed, so measure height and only drop sizes once the
       pill would run to a third. That keeps far more of the size run visible
       than squeezing it onto one line ever did. */
    var lineH = parseFloat(window.getComputedStyle(tag).lineHeight) || 12;
    var maxH = (lineH * 2) + 2;
    function overflows() {
      return tag.scrollWidth > room + 1 || tag.scrollHeight > maxH;
    }

    function paint(n) {
      var txt = ': ' + all.slice(0, n).join(', ');
      var left = all.length - n;
      if (left > 0) txt += ' +' + left + ' more';
      szEl.textContent = txt;
    }
    /* widest first, then drop one at a time until the pill fits */
    var n = all.length;
    paint(n);
    while (n > 1 && overflows()) { n -= 1; paint(n); }
    /* if even one size will not fit, drop the list rather than clip it */
    if (n === 1 && overflows()) { szEl.textContent = ''; szEl.hidden = true; }
  }

  /* ---------------- boot ---------------- */
  /* Every init below used to run bare inside one function, so a single throw
     anywhere in the list silently killed every init after it - and initProduct
     (the PDP size pills, add to cart, accordions) sits near the end. Each step
     is now isolated: one failing section can no longer take the page down, and
     the console names the step that failed. */
  function amSafe(name, fn) {
    try { fn(); } catch (err) { if (window.console && console.error) { console.error('[AM] init failed: ' + name, err); } }
  }
  function boot() {
    amSafe('announce', function(){ $$('[data-am-announce]').forEach(initAnnounce); });
    amSafe('usp-draw', function(){ $$('[data-am-usp]').forEach(initUspDraw); });
    amSafe('usp-carousel', function(){ $$('[data-am-usp]').forEach(initUspCarousel); });
    amSafe('collection', function(){ $$('[data-am-collection]').forEach(initCollection); });
    amSafe('header', function(){ $$('[data-am-header]').forEach(initHeader); });
    amSafe('mega', function(){ $$('[data-am-header]').forEach(initMega); });
    amSafe('menu-drops', function(){ $$('[data-am-header]').forEach(initMenuDrops); });
    amSafe('drawer-nav', function(){ $$('[data-am-header]').forEach(initDrawerNav); });
    amSafe('pslider', function(){ initPSlider(document); });
    amSafe('search-drawer', initSearchDrawer);
    amSafe('promise-draw', initPromiseDraw);
    amSafe('product-cards', function(){ initProductCards(document); });
    amSafe('zoom', function(){ initZoom(document); });
    amSafe('circnav', initCircNav);
    amSafe('tiles-carousel', function(){ initTilesCarousel(document); });
    amSafe('footer-accordion', function(){ initFooterAccordion(document); });
    amSafe('quick-view', initQuickView);
    amSafe('reveal', initReveal);
    /* AM Custom Size Store reveal + parallax */
    amSafe('amcs-anim', function(){ $$('[data-amcs-anim]').forEach(function (root) {
      var items = $$('.amcs-hero,.amcs-feat', root);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        items.forEach(function (el) { io.observe(el); });
        setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 1600);
      } else { items.forEach(function (el) { el.classList.add('is-in'); }); }
      var bg = root.querySelector('.amcs-hero-bg'), hero = root.querySelector('.amcs-hero');
      if (bg && hero && window.matchMedia('(hover:hover)').matches) {
        on(hero, 'mousemove', function (ev) { var r = hero.getBoundingClientRect(); var x = (ev.clientX - r.left) / r.width - 0.5; var y = (ev.clientY - r.top) / r.height - 0.5; bg.style.transform = 'scale(1.06) translate(' + (x * -10) + 'px,' + (y * -10) + 'px)'; });
        on(hero, 'mouseleave', function () { bg.style.transform = ''; });
      }
    }); });
    amSafe('hero', function(){ $$('[data-am-hero]').forEach(initHero); });
    amSafe('tabs', function(){ $$('[data-am-tabs]').forEach(initTabs); });
    amSafe('lookbook', function(){ $$('[data-am-lookbook]').forEach(initLookbook); });
    amSafe('lookbook-carousel', function(){ $$('[data-am-lookbook]').forEach(initLookCarousel); });
    amSafe('review-carousel', function(){ document.querySelectorAll('[data-am-revcar]').forEach(function(c){initReviewCarousel(c.closest('.am-section')||document);}); });
    amSafe('newsletter', function(){ $$('[data-am-newsletter]').forEach(initNewsletter); });
    amSafe('related', function(){ $$('[data-am-related]').forEach(initRelated); });
    amSafe('product', function(){ $$('[data-am-product]').forEach(initProduct); });
    amSafe('wishlist', wishInit);
    amSafe('wishlist-page', function(){ $$('[data-am-wishpage]').forEach(initWishlistPage); });
    amSafe('cart-count', updateCartCount);
    amSafe('cart-drawer', function(){ AMCart.init(); });
    amSafe('cart-marquee', function(){ initCartMarquee(); });
    amSafe('cart-note', function(){ initCartNote(); });
    amSafe('sg-slider', function(){ initSgSliders(); });
    amSafe('wish-drawer', function(){ AMWish.init(); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  /* re-init inside theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('[data-am-announce]', s.parentElement).forEach(initAnnounce);
    if (s.querySelector('[data-am-usp]')) { initUspDraw(s.querySelector('[data-am-usp]')); initUspCarousel(s.querySelector('[data-am-usp]')); }
    if (s.querySelector('[data-am-collection]')) initCollection(s.querySelector('[data-am-collection]'));
    if (s.querySelector('[data-am-header]')) { initHeader(s.querySelector('[data-am-header]')); initMega(s.querySelector('[data-am-header]')); initMenuDrops(s.querySelector('[data-am-header]')); initDrawerNav(s.querySelector('[data-am-header]')); }
    if (s.querySelector('[data-am-hero]')) initHero(s.querySelector('[data-am-hero]'));
    if (s.querySelector('[data-am-tabs]')) initTabs(s.querySelector('[data-am-tabs]'));
    if (s.querySelector('[data-am-lookbook]')) { initLookbook(s.querySelector('[data-am-lookbook]')); initLookCarousel(s.querySelector('[data-am-lookbook]')); }
    if (s.querySelector('[data-am-related]')) initRelated(s.querySelector('[data-am-related]'));
    if (s.querySelector('[data-am-wishpage]')) initWishlistPage(s.querySelector('[data-am-wishpage]'));
    if (s.querySelector('[data-am-product]')) initProduct(s.querySelector('[data-am-product]'));
    /* These were missing, so a section edited in the theme editor came back with
       its carousel, cards, zoom and accordion unbound - the components looked
       broken in the customizer while working fine on the live page. */
    initTilesCarousel(s);
    initProductCards(s);
    initReviewCarousel(s);
    initFooterAccordion(s);
    if (typeof initPSlider === 'function') initPSlider(s);
    if (typeof initZoom === 'function') initZoom(s);
    wishInit();
  });

  /* ----------------------------------------------------------------
     Sticky header height.
     The header sticks at top:0 with z-index 500. Anything else that
     also sticks at top:0 - the circular collection nav most visibly -
     slides underneath it and only its lower half stays on screen.
     --am-sticky-top was read in three rules but never actually set,
     so it had been falling back to 24px and the product page columns
     tucked under the header as well. Measuring once and republishing
     on resize gives every sticky element a real offset to clear.
  ---------------------------------------------------------------- */

  /* ============================================================
     AM CART PAGE
     Same behaviours as the drawer - quantity, remove, order note
     and per-line note - applied to the full page rows. Updates in
     place via cart/change.js rather than reloading, and preserves
     each line's other properties when saving a note, so anything
     captured on the product page survives the edit.
     ============================================================ */
  function initCartPage() {
    var root = document.querySelector('[data-am-cartpage]');
    if (!root || root.__amCP) return;
    root.__amCP = true;

    function money(c) {
      return 'Rs. ' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sub = root.querySelector('[data-am-cartpage-subtotal]');
          if (sub) sub.textContent = money(cart.total_price);
          var cnt = root.querySelector('[data-am-cartpage-count]');
          if (cnt) cnt.textContent = cart.item_count + (cart.item_count === 1 ? ' piece' : ' pieces');
          var badges = document.querySelectorAll('[data-am-cart-count]');
          for (var i = 0; i < badges.length; i++) badges[i].textContent = cart.item_count;
          if (cart.item_count === 0) window.location.reload();
          return cart;
        }).catch(function () { return null; });
    }

    function change(body) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok ? r.json() : null; });
    }

    root.addEventListener('click', function (e) {
      var row = e.target.closest('[data-am-cpi]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyEl = row.querySelector('[data-am-cpi-qty]');
      var cur = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

      if (e.target.closest('[data-am-cpi-note-toggle]')) {
        var nb = row.querySelector('[data-am-cpi-note]');
        var tg = e.target.closest('[data-am-cpi-note-toggle]');
        if (nb) {
          nb.hidden = !nb.hidden;
          tg.setAttribute('aria-expanded', nb.hidden ? 'false' : 'true');
          if (!nb.hidden) { var ta = nb.querySelector('textarea'); if (ta) ta.focus(); }
        }
        return;
      }

      var next = null;
      if (e.target.closest('[data-am-cpi-inc]')) next = cur + 1;
      else if (e.target.closest('[data-am-cpi-dec]')) next = Math.max(0, cur - 1);
      else if (e.target.closest('[data-am-cpi-remove]')) next = 0;
      if (next === null) return;

      e.preventDefault();
      change({ id: key, quantity: next }).then(function (cart) {
        if (!cart) return;
        if (next === 0) { row.remove(); }
        else {
          if (qtyEl) qtyEl.textContent = next;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) {
              var t = row.querySelector('[data-am-cpi-total]');
              if (t) t.textContent = money(cart.items[i].final_line_price);
              break;
            }
          }
        }
        refresh();
      });
    });

    /* per-line note, saved on blur - an unsaved note is worse than none,
       because the customer believes the instruction was sent */
    root.addEventListener('blur', function (e) {
      var ta = e.target.closest('[data-am-cpi-note-input]');
      if (!ta) return;
      var row = ta.closest('[data-am-cpi]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = null;
          for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) item = cart.items[i];
          var props = {};
          if (item && item.properties) {
            Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
          }
          var val = (ta.value || '').trim();
          if (val) { props['Note'] = val; } else { delete props['Note']; }
          return change({ id: key, properties: props }).then(function () {
            var lbl = row.querySelector('[data-am-cpi-note-label]');
            if (lbl) lbl.textContent = val ? 'Edit note' : 'Add a note';
            var ok = row.querySelector('[data-am-cpi-note-saved]');
            if (ok) {
              ok.hidden = false;
              clearTimeout(ok.__t);
              ok.__t = setTimeout(function () { ok.hidden = true; }, 1600);
            }
          });
        }).catch(function () {});
    }, true);

    /* order note */
    var oTog = root.querySelector('[data-am-cartpage-note-toggle]');
    var oBody = root.querySelector('[data-am-cartpage-note-body]');
    if (oTog && oBody) {
      oTog.addEventListener('click', function () {
        oBody.hidden = !oBody.hidden;
        oTog.setAttribute('aria-expanded', oBody.hidden ? 'false' : 'true');
        if (!oBody.hidden) { var ta = oBody.querySelector('textarea'); if (ta) ta.focus(); }
      });
    }
    var oIn = root.querySelector('[data-am-cartpage-note-input]');
    if (oIn) {
      oIn.addEventListener('blur', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: oIn.value || '' })
        }).then(function () {
          var ok = root.querySelector('[data-am-cartpage-note-saved]');
          if (ok) {
            ok.hidden = false;
            clearTimeout(ok.__t);
            ok.__t = setTimeout(function () { ok.hidden = true; }, 1600);
          }
        }).catch(function () {});
      });
    }
  }


  /* ============================================================
     AM FAQ - accordion plus category filtering
     ============================================================ */
  function initFaq() {
    var root = document.querySelector('.am-faq');
    if (!root || root.__amFaq) return;
    root.__amFaq = true;

    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-am-faq-q]');
      if (q) {
        var item = q.closest('[data-am-faq-item]');
        var a = item && item.querySelector('[data-am-faq-a]');
        if (!a) return;
        var openNow = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', openNow ? 'false' : 'true');
        a.hidden = openNow;
        return;
      }

      var cat = e.target.closest('[data-am-faq-cat]');
      if (!cat) return;
      var want = cat.getAttribute('data-am-faq-cat');
      var btns = root.querySelectorAll('[data-am-faq-cat]');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i] === cat;
        btns[i].classList.toggle('is-active', on);
        btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var items = root.querySelectorAll('[data-am-faq-item]');
      var shown = 0;
      for (var j = 0; j < items.length; j++) {
        var match = want === 'all' || items[j].getAttribute('data-cat') === want;
        items[j].hidden = !match;
        if (match) shown++;
      }
      var empty = root.querySelector('[data-am-faq-empty]');
      if (empty) empty.hidden = shown !== 0;
    });
  }

  /* ----------------------------------------------------------------
     Compact the collection circles on scroll.
     The strip is sticky under the header, so at full height it took a
     large slice of the viewport the whole way down the page. Past a
     threshold it shrinks to about half height, and it expands again
     near the top. Hysteresis - a higher threshold going down than
     coming back up - stops it flickering when a scroll lands right on
     the boundary.
  ---------------------------------------------------------------- */
  /* The product form exists so GoKwik can bind to it; it is never meant to
     post on its own. Our buttons are type="button", but Enter in the quantity
     or note field would still submit it and reload the page, losing the
     customisation fields. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[data-am-product-form]')) e.preventDefault();
  }, true);

  /* ----------------------------------------------------------------
     Hand off to checkout.
     GoKwik cancels a claimed link's default and opens its own checkout;
     it cannot intercept a JS redirect, so going straight to /checkout
     would bypass it. Clicking a link it has actually claimed is the
     only reliable handover. Shared by the product page and quick view
     so both behave identically.
  ---------------------------------------------------------------- */
  function amCheckoutHandoff() {
    var links = document.querySelectorAll('a[href*="/checkout"][data-gokwik-processed]');
    var link = null;
    for (var i = 0; i < links.length; i++) {
      /* prefer one on screen - the drawer's link sits translated off to
         the right while the drawer is shut */
      if (links[i].getBoundingClientRect().width > 0) { link = links[i]; break; }
    }
    if (!link && links.length) link = links[0];
    if (!link) { window.location.href = '/checkout'; return; }

    /* If GoKwik's SDK is not ready, is blocked, or fails quietly, the click
       does nothing at all and the button looks dead. Watch for navigation
       or a GoKwik overlay, and fall back if neither arrives. */
    var handed = false;
    function markHanded() { handed = true; }
    window.addEventListener('beforeunload', markHanded, { once: true });
    window.addEventListener('pagehide', markHanded, { once: true });

    link.click();

    setTimeout(function () {
      if (handed) return;
      var overlay = document.querySelector('iframe[src*="gokwik"], [id*="gokwik" i], [class*="gokwik" i]');
      if (overlay && overlay.getBoundingClientRect().height > 0) return;
      window.location.href = '/checkout';
    }, 1500);
  }

  function amCircnavCompact() {
    var wrap = document.querySelector('.am-circnav-wrap');
    if (!wrap) return;
    var compact = wrap.classList.contains('is-compact');
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!compact && y > 140) {
      wrap.classList.add('is-compact');
    } else if (compact && y < 90) {
      wrap.classList.remove('is-compact');
    }
  }
  var amCircTick = false;
  function amCircnavOnScroll() {
    if (amCircTick) return;
    amCircTick = true;
    window.requestAnimationFrame(function () {
      amCircnavCompact();
      amCircTick = false;
    });
  }
  window.addEventListener('scroll', amCircnavOnScroll, { passive: true });

  function amHeaderH() {
    var sec = document.getElementById('shopify-section-am-header');
    var el = sec || document.querySelector('.am-header');
    if (!el) return;
    var h = Math.round(el.getBoundingClientRect().height);
    if (!h) return;
    var root = document.documentElement;
    root.style.setProperty('--am-header-h', h + 'px');
    root.style.setProperty('--am-sticky-top', (h + 16) + 'px');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { amHeaderH(); initCartPage(); initFaq(); amCircnavCompact(); });
  } else {
    amHeaderH();
    initCartPage();
    initFaq();
    amCircnavCompact();
  }
  window.addEventListener('load', amHeaderH);
  window.addEventListener('resize', function () {
    clearTimeout(window.__amHdrT);
    window.__amHdrT = setTimeout(amHeaderH, 120);
  });
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { amHeaderH(); initCartPage(); initFaq(); amCircnavCompact(); }, 60); });
})();
